import { toast } from "react-toastify";
import Button from "../../components/global/button/Button";
import { Accordion, Modal, ModalBody, ModalFooter } from "react-bootstrap";
import "../payment/css/payment-modal.scss";
import { useNavigate } from "react-router";
import RoutingPaths from "../../utils/RoutingPaths";
import React, { Fragment, useEffect, useState } from "react";
import { payTabIndexFun } from "../../utils/GlobalData";
import {
  addInvoiceService,
  getAllPackage,
  getBillCodes,
  getPreDefinedPackages,
  updateInvoiceService,
} from "../../services/api_services/PaymentService";
import moment from "moment";
import "./addInvoice.scss";
import CreatableSelect from "react-select/creatable";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { EnhancedTableHead } from "../../components/dashboard/table_component/TableComponent";
import IconButton from "../../components/global/button/IconButton";
import AddBillCodeForGenerateInvoice from "../payment/AddBillCodeModalForGenerateInvoice";
import BuyPackageModal from "./BuyPackageModal";
import {
  getAllMedicalProcedureByClientIdConsultantIdList,
  getClientByValue,
  getMedicinesToBePaidByClientIdAndConsultantIdList,
  getPrescriptionByAppointmentId,
} from "../../services/api_services/AppointmentServices";
import SelectAppointmentModal from "./SelectAppointmentModal";
import { convertDateToString } from "../../utils/HelperFunctions";
import SectionLoader from "../../components/global/loader/SectionLoader";
import { getAddressListAPI } from "../../services/api_services/AddressServices";
import { getVaccinesToBePaidByClientIdList } from "../../services/api_services/ClientServices";
import {
  getHospitalizationCheckUpBillItems,
  getHospitalizationRoomBillItems,
} from "../../services/api_services/HospitalizationServices";
import {
  getContentMeasurementUnitMedicalProduct,
  getMedicalProductBillCodes,
  getMedicalProductListByMedicine,
  getSuggestedMedicalProductBatches,
} from "../../services/api_services/MedicalInventoryProductServices";
import "../../pages/org_dashboard/inventory/MedicalProduct.scss";
import { DATA_NOT_AVAILABLE } from "../../utils/Constants";

export default function AddInvoiceModal(props) {
  const navigate = useNavigate();
  const consultant = sessionStorage.getItem("ConsultantDetails");
  const isConsultantUser = consultant !== null;
  const [billArray, setBillArray] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});

  const organizationFlagDetails = JSON.parse(
    sessionStorage.getItem("OrgDetails2")
  );
  const [isBillWithGst, setIsBillWithGst] = useState(
    organizationFlagDetails?.billWithGst ? true : false
  );
  const [headCells] = useState([
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      disableSorting: true,
      label: "No",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      disableSorting: true,
      label: "Name",
    },
    // Include HSN/SAC if isBillWithGst TRUE
    ...(isBillWithGst
      ? [
          {
            id: "hsn_sac_code",
            numeric: false,
            disablePadding: false,
            disableSorting: true,
            label: "HSN/SAC Code",
          },
        ]
      : []),
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      disableSorting: true,
      label: "Description",
    },
    {
      id: "quantity",
      disablePadding: false,
      disableSorting: true,
      label: "Qty",
    },
    {
      id: "discount",
      numeric: true,
      disablePadding: false,
      disableSorting: true,
      label: "Disc",
    },
    // Include CGST and SGST if isBillWithGst true
    ...(isBillWithGst
      ? [
          {
            id: "cgst",
            numeric: true,
            disablePadding: false,
            disableSorting: true,
            label: "CGST",
          },
          {
            id: "sgst",
            numeric: true,
            disablePadding: false,
            disableSorting: true,
            label: "SGST",
          },
        ]
      : []),
    {
      id: "rate",
      numeric: false,
      disablePadding: false,
      disableSorting: true,
      label: "Rate",
    },
    {
      id: "amount",
      numeric: false,
      disablePadding: false,
      disableSorting: true,
      label: "Amount",
    },
  ]);

  const [todaysDate] = useState(new Date().getTime());
  const [isAddInvoiceLoading, setIsAddInvoiceLoading] = useState(false);
  const [invoiceDueDate, setInvoiceDueDate] = useState(todaysDate);
  const [invoiceCreateDate, setInvoiceCreateDate] = useState(todaysDate);
  const [total, setTotal] = useState(0);
  const [isSelectedBillCode, setIsSelectBillCode] = useState(true);
  const [billCodeListResponse, setBillCodeListResponse] = useState([]);
  const [delay] = useState(400);
  const [billCodeList, setBillCodeList] = useState([]);
  const [rowNoToGenerateDropdown, setRowNoToGenerateDropdown] = useState("");
  const [startAddBillCodeModal, setStartAddBillCodeModal] = useState(false);
  const [billItemToSave, setBillItemToSave] = useState("");
  const [indexOfNewBillItem, SetIndexOfNewBillItem] = useState("");
  const [isBuyPackageModal, setIsBuyPackageModal] = useState(false);
  const [validPackageList, setValidPackageList] = useState([]);
  const [packageObj, setPackageObj] = useState("");
  const [servicePackageId, setServicePackageId] = useState("");
  const [isConsumePackage, setIsConsumePackage] = useState(false);
  const [preDefinedPackageList, setPreDefinedPackageList] = useState("");
  const [servicePackDiscount, setServicePackDiscount] = useState("");
  const [tempBillArray, setTempBillArray] = useState([]);
  const searchData = "";
  const page = 0;
  const clientsPerPage = 30;
  const rowsPerPage = parseInt(Number.MAX_SAFE_INTEGER);
  const [packageList, setPackageList] = useState([]);
  const [isShowPackages, setIsShowPackages] = useState(true);
  const [newPackList, setNewPackList] = useState([]);
  const [
    pendingMedicalProcedureToothNoList,
    setPendingMedicalProcedureToothNoList,
  ] = useState([]);
  const [
    pendingMedicalProcedureItemIdList,
    setPendingMedicalProcedureItemIdList,
  ] = useState([]);
  const [listOfMedicinesToBePaid, setListOfMedicinesToBePaid] = useState([]);
  const [listOfVaccinesToBePaid, setListOfVaccinesToBePaid] = useState([]);

  const [selectedAppointment, setSelectedAppointment] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [withAppointment, setWithAppointment] = useState(false);
  const [pendingSubTreatmentItemIdList, setPendingSubTreatmentItemIdList] =
    useState([]);
  const [pendingSubTreatmentItemList, setPendingSubTreatmentItemList] =
    useState([]);
  const [errorMessage, setErrorMessage] = useState({});
  const [clientList, setClientList] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [searchClient, setSearchClient] = useState("");
  const [isSelectAppointmentModal, setIsSelectAppointmentModal] =
    useState(false);
  const [isAppointmentSelected, setIsAppointmentSelected] = useState(false);
  const [noOfSessionConsumed, setNoOfSessionsConsumed] = useState(1);
  const maxInteger = 2147483647;
  const [remainingSession, setRemainingSessions] = useState();
  const [isShowBillArray, setIsShowBillArray] = useState(false);
  const [orgAddressList, setOrgAddressList] = useState([]);
  const [addressId, setAddressId] = useState("");

  const [isPrescriptionLoading, setIsPrescriptionLoading] = useState(false);
  const [medicineList, setMedicineList] = useState([]);
  const [isMedicalProductListLoading, setIsMedicalProductListLoading] =
    useState(false);
  const [medicalProductList, setMedicalProductList] = useState([]);
  const [selectedMedicalProductList, setSelectedMedicalProductList] = useState(
    []
  );
  const [hideSelectMedicalProduct, setHideSelectMedicalProduct] =
    useState(false);
  const [medicalProductBillCodeList, setMedicalProductBillCodeList] = useState(
    []
  );
  const [showMedicalBillCodes, setShowMedicalBillCodes] = useState(false);
  const organizationDto = JSON.parse(sessionStorage.getItem("OrgDetails2"));
  const [
    suggestedMedicalProductBatchList,
    setSuggestedMedicalProductBatchList,
  ] = useState([]);
  const [contentMeasurementUnitList, setContentMeasurementUnitList] = useState(
    []
  );
  const [selectedBatchMap, setSelectedBatchMap] = useState({});

  const appointmentId = props.isEditInvoiceModal
    ? props.appointmentId
    : props?.generateInvoiceWithoutAppointment
    ? withAppointment
      ? selectedItems[0]
      : null
    : props.appointmentInfo?.id;

  const [
    isMedicalProductBillCodeListLoading,
    setIsMedicalProductBillCodeListLoading,
  ] = useState(false);

  useEffect(() => {
    if (props.show) {
      setIsShowBillArray(true);
      if (props.isEditInvoiceModal) {
        setNoOfSessionsConsumed(
          props.Invoice?.consumeCount === 0 ? 1 : props.Invoice?.consumeCount
        );
        setInvoiceDueDate(props.Invoice.dueDate);
        setInvoiceCreateDate(props.Invoice.createDate);
        getAllPreDefinedPackages();
        getBillCodesInfo();
        setListOfMedicinesToBePaid(props?.Invoice?.medicineList);
        setListOfVaccinesToBePaid(
          props?.Invoice?.vaccineRecordList === null
            ? []
            : props?.Invoice?.vaccineRecordList
        );
        setListOfVaccinesToBePaid(
          props?.Invoice?.vaccineRecordList === null
            ? []
            : props?.Invoice?.vaccineRecordList
        );
      } else {
        getBillCodesInfo();
        getAllPreDefinedPackages();
        if (
          !props.isGenerateInvoiceWithoutAppointmentModal &&
          !props?.hospitalizationId
        ) {
          getPackageInfo();
        }
      }

      if (
        props.isGenerateInvoiceWithoutAppointmentModal ||
        props?.appointmentId === null
      ) {
        setInvoiceCreateDate(todaysDate);
        getClientListHandler(searchData, page, clientsPerPage);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  useEffect(() => {
    const handleOrgUpdate = () => {
      const updatedOrg = JSON.parse(sessionStorage.getItem("OrgDetails2"));
      setIsBillWithGst(updatedOrg?.billWithGst ? true : false);
    };

    window.addEventListener("orgDetailsUpdated", handleOrgUpdate);

    return () => {
      window.removeEventListener("orgDetailsUpdated", handleOrgUpdate);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (props.show && appointmentId && organizationDto?.isMedicalInventory) {
      getPrescriptionByAppointmentIdHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show, appointmentId]);

  useEffect(() => {
    if (medicineList && medicineList.length > 0) {
      getMedicalProductListByMedicineHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [medicineList]);

  useEffect(() => {
    if (props.show) {
      getClientListHandler(searchClient, page, clientsPerPage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show, searchClient]);

  useEffect(() => {
    if (props?.isGenerateInvoiceWithoutAppointmentModal && !withAppointment) {
      getAddressListAPIHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props?.show,
    props?.isGenerateInvoiceWithoutAppointmentModal,
    withAppointment,
  ]);

  useEffect(() => {
    if (props.show && isAppointmentSelected && selectedAppointment) {
      getAllMedicalProcedureByClientIdConsultantIdListHandler();

      getMedicinesToBePaid();
      getVaccinesToBePaid();
    }

    if (props.hospitalizationId && props.show) {
      getHospitalizationRoomBillItemsHandler();
      getHospitalizationCheckUpBillItemsHandler();
    }

    if (
      props.show &&
      !(
        (props?.appointmentId !== null && props?.appointmentId) ||
        props.appointmentInfo !== undefined
      ) &&
      !withAppointment
    ) {
      setSelectedItems([]);
      if (billArray.length > 0) {
        const updatedBillArray = billArray.filter(
          (item) => !item.isMedicalProcedure
        );
        setBillArray(updatedBillArray);
      }
    }

    if (selectedAppointment && !props?.hospitalizationId) {
      getPackageInfo();
    }
    if (withAppointment) {
      setSelectedClient("");
      setAddressId("");
    } else {
      setSelectedAppointment();
      setSelectedItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show, isAppointmentSelected, withAppointment]);

  useEffect(() => {
    calculateTotalSubtotal(billArray, packageList);
    if (
      packageList &&
      packageList.length === 0 &&
      !validPackageList &&
      props.isEditInvoiceModal
    ) {
      setIsShowPackages(false);
      setServicePackageId("");
      setIsConsumePackage(false);
    } else {
      setIsShowPackages(
        !validPackageList && validPackageList.length === 0 ? false : true
      );
    }

    const removeDuplicates = (list) => {
      return list.filter((item, index) => list.indexOf(item) === index);
    };

    setValidPackageList(removeDuplicates(validPackageList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packageList, billArray]);

  const getColumnIndexByLabel = (label) => {
    return headCells.findIndex((cell) => cell.label === label);
  };

  const getBillCodesInfo = async () => {
    const response = await getBillCodes();

    setBillCodeListResponse(response);
    if (props?.isEditInvoiceModal) {
      if (props?.Invoice && Object.keys(props?.Invoice).length) {
        let packNameList = [];
        if (
          props?.Invoice?.predefinedPackagesList &&
          props?.Invoice?.predefinedPackagesList.length > 0
        ) {
          packNameList = props?.Invoice?.predefinedPackagesList.map(
            (pack) => pack.name
          );
        }

        let medicineNameList = [];

        if (
          props?.Invoice?.medicineList &&
          props?.Invoice?.medicineList.length > 0
        ) {
          medicineNameList = props?.Invoice?.medicineList.map((pack) =>
            pack.name.trim()
          );
        }

        let vaccineNameList = [];

        if (
          props?.Invoice?.vaccineRecordList &&
          props?.Invoice?.vaccineRecordList.length > 0
        ) {
          vaccineNameList = props?.Invoice?.vaccineRecordList.map((vaccine) =>
            vaccine.vaccineName.trim()
          );
        }

        let array = [];
        let arrayOfServicePack = [];
        let billItemAsPackageObj = {};
        for (const billItem in props?.Invoice?.billItemsDto) {
          const billItemsDto = props?.Invoice?.billItemsDto[billItem];
          if (billItemsDto.name === "") {
            continue;
          }

          let isMedicine = false;
          if (medicineNameList.length > 0) {
            isMedicine = medicineNameList.includes(billItemsDto.name.trim())
              ? true
              : false;
          }

          let isVaccine = false;
          if (vaccineNameList.length > 0) {
            isVaccine = vaccineNameList.includes(billItemsDto.name.trim())
              ? true
              : false;
          }

          if (
            props?.Invoice?.predefinedPackagesList &&
            props?.Invoice?.predefinedPackagesList.length > 0 &&
            packNameList.includes(billItemsDto.name)
          ) {
            let packObj = {};

            if (arrayOfServicePack.length > 0) {
              packObj = props?.Invoice?.predefinedPackagesList.find(
                (pack) =>
                  pack.name === billItemsDto.name &&
                  !arrayOfServicePack.includes(pack?.id)
              );
            } else {
              packObj = props?.Invoice?.predefinedPackagesList.find(
                (pack) => pack.name === billItemsDto.name
              );
            }

            if (packObj) {
              arrayOfServicePack.push(packObj?.id);
              updateSubtotalTotalForPackage(packObj);
            }
          } else {
            const obj = {
              ...billItemsDto,
              qnty: billItemsDto.qnty,
              amount: parseFloat(
                (
                  +billItemsDto.rate *
                  +billItemsDto.qnty *
                  (1 - +billItemsDto.discount / 100) *
                  (1 + (+billItemsDto.cgst + +billItemsDto.sgst) / 100)
                ).toFixed(2)
              ),
              discount: billItemsDto.discount,
              descr: billItemsDto.description,
              taxRate: (+billItemsDto.cgst || 0) + (+billItemsDto.sgst || 0),
              isMedicine: isMedicine,
              isVaccine: isVaccine,
              cgst: billItemsDto.cgst ? billItemsDto.cgst : 0,
              sgst: billItemsDto.sgst ? billItemsDto.sgst : 0,
              hsn_sac_code:
                billItemsDto.hsn_sac_code && billItemsDto.hsn_sac_code !== null
                  ? billItemsDto.hsn_sac_code
                  : "",
            };
            array = [...array, { ...obj }];
            setBillArray(array);
          }
        }

        setTempBillArray(array);
        calculateTotalSubtotal(array, billItemAsPackageObj);
        setInvoiceDueDate(
          props?.Invoice?.dueDate === 0 ? todaysDate : props?.Invoice?.dueDate
        );
        setInvoiceCreateDate(props?.Invoice?.createDate);

        if (
          props?.Invoice?.validPackList &&
          props?.Invoice?.validPackList.length > 0
        ) {
          setValidPackageList(props?.Invoice?.validPackList);
        } else {
          setValidPackageList([]);
        }

        if (
          props?.Invoice?.usedPackagesList &&
          props?.Invoice?.usedPackagesList.length > 0 &&
          !props?.Invoice?.predefinedPackagesList
        ) {
          setIsConsumePackage(true);
          setServicePackageId(props?.Invoice?.usedPackagesList[0].id);
          setServicePackDiscount(props?.Invoice?.usedPackagesList[0]?.discount);
          const usedPack = props?.Invoice?.usedPackagesList[0];

          if (
            props?.Invoice?.validPackList &&
            props?.Invoice?.validPackList.length > 0
          ) {
            const isServicePackPresent = props?.Invoice?.validPackList.find(
              (item) => item.id === usedPack.id
            );
            if (!isServicePackPresent) {
              setValidPackageList((validPackageList) => [
                ...validPackageList,
                usedPack,
              ]);
            }
          } else {
            setValidPackageList(props?.Invoice?.usedPackagesList);
          }
        } else if (
          props?.Invoice?.usedPackagesList &&
          props?.Invoice?.usedPackagesList.length > 0 &&
          props?.Invoice?.predefinedPackagesList &&
          props?.Invoice?.predefinedPackagesList.length > 0
        ) {
          setIsConsumePackage(true);
          setServicePackageId(props?.Invoice?.usedPackagesList[0].id);

          setServicePackDiscount(props?.Invoice?.usedPackagesList[0]?.discount);
          const usedPack = props?.Invoice?.usedPackagesList[0];

          if (
            props?.Invoice?.validPackList &&
            props?.Invoice?.validPackList.length > 0
          ) {
            const isServicePackPresent = props?.Invoice?.validPackList.find(
              (item) => item.id === usedPack.id
            );
            if (!isServicePackPresent) {
              setValidPackageList((validPackageList) => [
                ...validPackageList,
                usedPack,
              ]);
            }
          } else {
            setValidPackageList(props?.Invoice?.usedPackagesList);
          }
        }

        if (
          props?.Invoice.used_service_pack_id &&
          props?.Invoice.used_service_pack_id !== 0
        ) {
          setIsConsumePackage(true);
        }

        if (packageObj) {
          if (
            newPackList &&
            newPackList.length > 0 &&
            validPackageList &&
            validPackageList.length > 0 &&
            !newPackList
          ) {
            const updatedPackageList = validPackageList.filter(
              (item) => item.id !== packageObj.id
            );
            const isPresentInNewPackageList = newPackList.find((item) =>
              item.name.includes(packageObj.name)
            );
            if (
              isPresentInNewPackageList &&
              isPresentInNewPackageList !== undefined
            ) {
              setValidPackageList(updatedPackageList);
            } else {
              setValidPackageList(props?.Invoice?.usedPackagesList);
            }
          }
        }
        addMedicalProceduresToBillCode();
      }
      setIsShowBillArray(false);
    } else {
      const response = await getBillCodes();
      if (response.length) {
        /* 
          created 2 states from response as one will use for dropdown (since api call made only once)
          and second state will be used for posting user input bill items array
        */
        setBillCodeListResponse(response);
        let defaultBillCodes = response.filter(
          (billCode) => billCode.hsrCode === "default"
        );

        let array = defaultBillCodes.map((billCode) => {
          return {
            ...billCode,
            qnty: 1,
            amount: billCode.rate * ((100 + billCode.taxRate) / 100),
            discount: 0,
          };
        });
        setBillArray(array);
        calculateTotalSubtotal(array);
      } else {
        setBillCodeListResponse([
          {
            name: "",
            descr: "",
            qnty: "1",
            taxRate: "",
            discount: "",
            rate: "",
            amount: "",
            cgst: "",
            sgst: "",
            hsn_sac_code: "",
          },
        ]);
        setBillArray([
          {
            name: "",
            descr: "",
            qnty: "1",
            taxRate: "",
            discount: "",
            rate: "",
            amount: "",
            cgst: "",
            sgst: "",
            hsn_sac_code: "",
          },
        ]);
      }

      if (props.appointmentInfo && Object.keys(props.appointmentInfo).length) {
        getAllMedicalProcedureByClientIdConsultantIdListHandler();

        getMedicinesToBePaid();
        getVaccinesToBePaid();
      }

      if (props.hospitalizationId && props.show) {
        getHospitalizationRoomBillItemsHandler();
        getHospitalizationCheckUpBillItemsHandler();
      }

      setIsShowBillArray(false);
    }
  };

  const getHospitalizationRoomBillItemsHandler = async () => {
    const response = await getHospitalizationRoomBillItems(
      props.hospitalizationId
    );

    if (response && response.data) {
      const roomBillCodes = response.data;

      const tempBillList = roomBillCodes?.map((item) => ({
        bedNo: item?.bedNo,
        descr: item?.billItemDescription,
        name: item?.billItemName,
        fromDate: item?.fromDate,
        hospitalizationId: item?.hospitalizationId,
        id: item?.id,
        invoiceId: item?.invoiceId,
        isCurrentRoom: true,
        qnty: item?.quantity,
        rate: item?.rent,
        amount: item?.amount ? item?.amount : 0,
        taxRate: 0,
        discount: 0,
        roomNo: item?.roomNo,
        toDate: item?.toDate,
        wardNo: item?.wardNo,
        hospitalizationRoomId: item?.id,
        cgst: item.cgst ? item.cgst : 0 ,
        sgst: item.sgst ? item.sgst : 0 ,
        hsn_sac_code: item.hsn_sac_code ? item.hsn_sac_code :"",
      }));

      setBillArray((prevState) => {
        const updatedBillArray = [...prevState];

        tempBillList.forEach((newItem) => {
          const isDuplicate = prevState.some(
            (existingItem) => existingItem.id === newItem.id
          );

          if (!isDuplicate) {
            updatedBillArray.push(newItem);
          }
        });

        return updatedBillArray;
      });
    }
  };

  const getHospitalizationCheckUpBillItemsHandler = async () => {
    const response = await getHospitalizationCheckUpBillItems(
      props.hospitalizationId
    );

    if (response) {
      const checkUpBillCodes = response;

      const tempBillList = checkUpBillCodes?.map((item) => ({
        id: item?.checkUpIds?.[0],
        descr: item?.descr || item?.description || "",
        name: item?.name,
        hospitalizationId: item?.hospitalizationId,
        qnty: item?.qnty || 1,
        rate: item?.rate,
        amount: item.charges,
        taxRate: item?.taxRate || 0,
        discount: item?.discount || 0,
        checkUpIds: item?.checkUpIds,
        hsrCode: item?.hsrCode || item?.name,
        cgst: item.cgst ? item.cgst : 0 ,
        sgst: item.sgst ? item.sgst : 0 ,
        hsn_sac_code: item.hsn_sac_code ? item.hsn_sac_code :"",
      }));

      setBillArray((prevState) => {
        const updatedBillArray = [...prevState];

        tempBillList.forEach((newItem) => {
          const isDuplicate = prevState.some((existingItem) => {
            return (
              Array.isArray(existingItem.checkUpIds) &&
              existingItem.checkUpIds.includes(newItem.checkUpIds?.[0])
            );
          });

          if (!isDuplicate) {
            updatedBillArray.push(newItem);
          }
        });

        return updatedBillArray;
      });
    }
  };

  const getPackageInfo = async () => {
    let response;
    if (props?.generateInvoiceWithoutAppointment) {
      if (selectedAppointment) {
        response = await getAllPackage(selectedAppointment?.id);
      }
    } else {
      response = await getAllPackage(
        props.isEditInvoiceModal
          ? props?.appointmentId
          : props?.appointmentInfo?.id
      );
    }

    if (response && response?.data) {
      setValidPackageList(response?.data);
    } else {
      setValidPackageList([]);
    }
  };

  const getVaccinesToBePaid = async () => {
    let response;

    if (selectedAppointment) {
      if (billArray.length > 0) {
        const updatedBillArray = billArray.filter(
          (item) =>
            !item.isMedicine && !item.isMedicalProcedure && !item.isVaccine
        );
        setBillArray(updatedBillArray);
      }
      response = await getVaccinesToBePaidByClientIdList(
        selectedAppointment?.clientId
      );
    } else {
      response = await getVaccinesToBePaidByClientIdList(
        props?.appointmentInfo?.clientId
      );
    }

    if (response) {
      let tempBillList = [];
      const vaccinesToBePaid =
        response?.data && response?.data?.length > 0 ? response?.data : [];

      if (vaccinesToBePaid && vaccinesToBePaid.length === 0) {
        setListOfVaccinesToBePaid([]);
      }
      setListOfVaccinesToBePaid(vaccinesToBePaid);

      for (let i = 0; i < vaccinesToBePaid?.length; i++) {
        const obj = {
          name: `${vaccinesToBePaid[i]?.vaccineName} `,
          descr: `Vaccination - ${vaccinesToBePaid[i]?.vaccineName} `,
          qnty: 1,
          taxRate: 0,
          discount: 0,
          rate: vaccinesToBePaid[i]?.price,
          amount: vaccinesToBePaid[i]?.price,
          isVaccine: true,
          vaccineName: `${vaccinesToBePaid[i]?.vaccineName}`,
        };
        tempBillList = [...tempBillList, obj];
      }

      const updatedBillList = tempBillList;

      setBillArray((prevState) => {
        return [...prevState, ...updatedBillList];
      });

      tempBillList = [];
    }

    setIsAppointmentSelected(false);
  };

  const getMedicinesToBePaid = async () => {
    let response;

    if (selectedAppointment) {
      if (billArray.length > 0) {
        const updatedBillArray = billArray.filter(
          (item) =>
            !item.isMedicine && !item.isMedicalProcedure && !item.isVaccine
        );
        setBillArray(updatedBillArray);
      }
      response = await getMedicinesToBePaidByClientIdAndConsultantIdList(
        selectedAppointment?.clientId,
        selectedAppointment?.consultantId
      );
    } else {
      response = await getMedicinesToBePaidByClientIdAndConsultantIdList(
        props?.appointmentInfo?.clientId,
        props?.appointmentInfo?.consultantId
      );
    }

    if (response) {
      let tempBillList = [];
      const medicinesToBePaid = response?.data;

      if (medicinesToBePaid && medicinesToBePaid.length === 0) {
        setListOfMedicinesToBePaid([]);
      }
      setListOfMedicinesToBePaid(response?.data);

      for (let i = 0; i < medicinesToBePaid?.length; i++) {
        const obj = {
          name: `${medicinesToBePaid[i]?.name} `,
          descr: medicinesToBePaid[i]?.name,
          qnty: medicinesToBePaid[i]?.quantity,
          taxRate: 0,
          discount: 0,
          rate: medicinesToBePaid[i]?.unitCost,
          amount: medicinesToBePaid[i]?.totalCost,
          isMedicine: true,
          medicineName: `${medicinesToBePaid[i]?.name}`,
          cgst: 0,
          sgst: 0,
          hsn_sac_code: "",
        };
        tempBillList = [...tempBillList, obj];
      }

      const updatedBillList = tempBillList;

      setBillArray((prevState) => {
        return [...prevState, ...updatedBillList];
      });

      tempBillList = [];
    }

    setIsAppointmentSelected(false);
  };

  const getAllMedicalProcedureByClientIdConsultantIdListHandler = async () => {
    let response;

    if (selectedAppointment) {
      if (billArray.length > 0) {
        const updatedBillArray = billArray.filter(
          (item) => !item.isMedicalProcedure
        );
        setBillArray(updatedBillArray);
      }

      response = await getAllMedicalProcedureByClientIdConsultantIdList(
        selectedAppointment.clientId,
        selectedAppointment.consultantId
      );
    } else {
      response = await getAllMedicalProcedureByClientIdConsultantIdList(
        props?.appointmentInfo?.clientId,
        props?.appointmentInfo?.consultantId
      );
    }

    if (response) {
      let tempBillList = [];
      let itemList =
        response.data
          .prescribedMedicalProcedureItemDetailsWithPendingPaymentList;

      let prescribedSubTreatmentItemDetailsWithPendingPayment =
        response.data.prescribedSubTreatmentItemDetailsWithPendingPayment;

      if (itemList.length === 0) {
        setPendingMedicalProcedureToothNoList([]);
        setPendingMedicalProcedureItemIdList([]);
      }

      if (prescribedSubTreatmentItemDetailsWithPendingPayment.length === 0) {
        setPendingSubTreatmentItemIdList([]);
        setPendingSubTreatmentItemList([]);
      }

      for (let i = 0; i < itemList.length; i++) {
        if (!itemList[i].isToothPaymentCompleted) {
          const obj = {
            name: `${itemList[i]?.toothNumber} - ${itemList[i]?.treatmentName}`,
            descr: itemList[i]?.name,
            qnty: itemList[i]?.quantity,
            taxRate: 0,
            discount: 0,
            rate: itemList[i]?.rate,
            amount: itemList[i]?.rate,
            isMedicalProcedure: true,
            medicalProcedureName: `${itemList[i]?.toothNumber} - ${itemList[i]?.treatmentName}`,
            cgst: 0,
            sgst: 0,
            hsn_sac_code: "",
          };
          tempBillList = [...tempBillList, obj];

          setPendingMedicalProcedureItemIdList((prevState) => [
            ...prevState,
            itemList[i]?.id,
          ]);
          setPendingMedicalProcedureToothNoList((prevState) => [
            ...prevState,
            itemList[i],
          ]);
        }
      }

      for (
        let i = 0;
        i < prescribedSubTreatmentItemDetailsWithPendingPayment.length;
        i++
      ) {
        if (
          !prescribedSubTreatmentItemDetailsWithPendingPayment[i]
            ?.isSubTreatmentPaymentCompleted
        ) {
          const obj = {
            name: `${prescribedSubTreatmentItemDetailsWithPendingPayment[i]?.subTreatmentName} - ${prescribedSubTreatmentItemDetailsWithPendingPayment[i]?.treatmentName}`,
            descr:
              prescribedSubTreatmentItemDetailsWithPendingPayment[i]?.notes,
            qnty: 1,
            taxRate: 0,
            discount: 0,
            rate: prescribedSubTreatmentItemDetailsWithPendingPayment[i]?.rate,
            amount:
              prescribedSubTreatmentItemDetailsWithPendingPayment[i]?.rate,
            isMedicalProcedure: true,
            medicalProcedureName: `${prescribedSubTreatmentItemDetailsWithPendingPayment[i]?.subTreatmentName} - ${prescribedSubTreatmentItemDetailsWithPendingPayment[i]?.treatmentName}`,
          };
          tempBillList = [...tempBillList, obj];

          setPendingSubTreatmentItemIdList((prevState) => [
            ...prevState,
            prescribedSubTreatmentItemDetailsWithPendingPayment[i]?.id,
          ]);

          setPendingSubTreatmentItemList((prevState) => [
            ...prevState,
            prescribedSubTreatmentItemDetailsWithPendingPayment[i],
          ]);
        }
      }

      const updatedBillList = tempBillList;

      setBillArray((prevState) => {
        return [...prevState, ...updatedBillList];
      });

      tempBillList = [];
    }
    setIsAppointmentSelected(false);
  };

  const getClientListHandler = async (searchData, page, clientsPerPage) => {
    const response = await getClientByValue(searchData, page, clientsPerPage);
    if (response && response.status === 200) {
      const optionList = response.data.list.map((item) => {
        return {
          label: `${item.firstName} ${item.lastName}`,
          value: `${item.firstName} ${item.lastName}`,
          id: item.id,
        };
      });
      setClientList(optionList);
    } else if (response && response.status === 204) {
      setClientList([]);
    }
  };

  function addMedicalProceduresToBillCode() {
    const pendingMedicalProcedureToothIdList =
      props.Invoice.prescribedMedicalProcedureItemDtoList.map(
        (item) => item.id
      );
    setPendingMedicalProcedureItemIdList(pendingMedicalProcedureToothIdList);
    setPendingMedicalProcedureToothNoList(
      props.Invoice.prescribedMedicalProcedureItemDtoList
    );

    const pendingSubTreatmentItemIdList =
      props?.Invoice?.prescribedSubTreatmentItemDetailsDtoList.map(
        (item) => item.id
      );

    setPendingSubTreatmentItemIdList(pendingSubTreatmentItemIdList);
    setPendingSubTreatmentItemList(
      props?.Invoice?.prescribedSubTreatmentItemDetailsDtoList
    );
  }

  async function getAllPreDefinedPackages() {
    const response = await getPreDefinedPackages(page, rowsPerPage, "");
    if (response?.list) {
      setPreDefinedPackageList(response?.list);
    } else {
      setPreDefinedPackageList([]);
    }
  }

  const handleAddRow = () => {
    setBillArray([
      ...billArray,
      {
        name: "",
        descr: "",
        qnty: "",
        taxRate: "",
        discount: "",
        rate: "",
        amount: "",
        cgst: "",
        sgst: "",
        hsn_sac_code: "",
      },
    ]);
  };

  const handleDeleteRow = async (i, name) => {
    const newArray = [...billArray];

    newArray.splice(i, 1);
    setBillArray(newArray);

    const toothItem = pendingMedicalProcedureToothNoList.find(
      (item) => parseInt(item.toothNumber) === parseInt(name)
    );

    if (toothItem) {
      const toothNoList = pendingMedicalProcedureToothNoList.filter(
        (item) => toothItem.toothNumber !== item.toothNumber
      );
      setPendingMedicalProcedureToothNoList(toothNoList);
      const toothItemList = pendingMedicalProcedureToothNoList.filter(
        (item) => toothItem.id !== item.id
      );

      const toothIdList = toothItemList.map((item) => item.id);

      setPendingMedicalProcedureItemIdList(toothIdList);
    }

    const subTreatmentItem = pendingSubTreatmentItemList.find(
      (item) => `${item.subTreatmentName} - ${item.treatmentName}` === name
    );

    if (subTreatmentItem) {
      const subTreatmentList = pendingSubTreatmentItemList.filter(
        (item) => subTreatmentItem.subTreatmentName !== item.subTreatmentName
      );
      setPendingSubTreatmentItemList(subTreatmentList);

      const subTreatmentItemList = pendingSubTreatmentItemList.filter(
        (item) => subTreatmentItem.id !== item.id
      );

      const subTreatmentIdList = subTreatmentItemList.map((item) => item.id);

      setPendingSubTreatmentItemIdList(subTreatmentIdList);
    }

    const medicine = listOfMedicinesToBePaid?.find(
      (item) => item.name.trim() === name.trim()
    );

    const medicines = new Set();
    const medicinesToBePaidList = [];
    if (medicine) {
      listOfMedicinesToBePaid.filter((item) => {
        if (medicines.has(item.name) && medicine.name === item.name) {
          medicinesToBePaidList.push(item);
          return false;
        }
        medicines.add(item.name);
        if (medicine.name !== item.name) {
          medicinesToBePaidList.push(item);
          return true;
        }
        return true;
      });
    }

    const vaccine = listOfVaccinesToBePaid?.find(
      (item) => item.vaccineName.trim() === name.trim()
    );

    const Vaccines = new Set();
    const vaccinesToBePaidList = [];
    if (vaccine && vaccine !== null) {
      listOfVaccinesToBePaid.filter((item) => {
        if (
          Vaccines.has(item.vaccineName) &&
          vaccine.vaccineName === item.vaccineName
        ) {
          vaccinesToBePaidList.push(item);
          return false;
        }

        Vaccines.add(item.vaccineName);
        if (vaccine.vaccineName !== item.vaccineName) {
          vaccinesToBePaidList.push(item);
          return true;
        }
        return true;
      });

      setListOfVaccinesToBePaid(vaccinesToBePaidList);
    }

    calculateTotalSubtotal(newArray, packageList);
  };

  const handleDeletePackageRow = async (i, packItem) => {
    const newArray = [...packageList];
    newArray.splice(i, 1);
    setPackageList(newArray);
    calculateTotalSubtotal(newArray, packageList);

    const packToRemove = validPackageList.find(
      (item) => item.id === servicePackageId
    );
    const updatedValidServicePacks = validPackageList.filter((item) => {
      if (item.name.includes(packItem?.name)) {
        if (item.remainingSessions === 0) {
          return true;
        }
        if (item.remainingSessions === 0 && item.id !== servicePackageId) {
          return true;
        }
        return false;
      }

      return true;
    });

    setValidPackageList(updatedValidServicePacks);
    if (
      packToRemove &&
      packToRemove.id === servicePackageId &&
      packToRemove.name.includes(packItem?.name)
    ) {
      setServicePackageId("");
      setIsConsumePackage(false);
    }
  };

  function checkDuplicateBillItem(listToCheck) {
    let emptyRowFound = false;
    let emptyRowIndex;
    listToCheck.map((item, i) => {
      if (
        !item.name ||
        !item.qnty ||
        item.rate === null ||
        item.rate === undefined ||
        item.rate < 0 ||
        item.rate === ""
      ) {
        emptyRowIndex = i + 1;
        emptyRowFound = true;
      }
      return null;
    });

    if (emptyRowFound) {
      toast.warning(
        `Bill item at no. ${emptyRowIndex} found empty. (Please fill up all fields)`
      );
      return true;
    }

    if (
      !invoiceDueDate ||
      moment(invoiceDueDate).format("YYYY-MM-DD") <
        moment(invoiceCreateDate).format("YYYY-MM-DD") ||
      invoiceDueDate === 0
    ) {
      toast.warning("Invoice due date is invalid!");
      return true;
    }

    if (selectedAppointment) {
      if (
        !invoiceCreateDate ||
        moment(invoiceCreateDate).format("YYYY-MM-DD") <
          moment(selectedAppointment?.visitDate).format("YYYY-MM-DD") ||
        invoiceCreateDate === 0
      ) {
        toast.warning("Invoice date is invalid!");
        return true;
      }
    }

    if (
      (props?.appointmentId !== null && props?.appointmentId) ||
      props.appointmentInfo !== undefined
    ) {
      if (
        !invoiceCreateDate ||
        moment(invoiceCreateDate).format("YYYY-MM-DD") <
          moment(props?.appointmentDetails?.visitDate).format("YYYY-MM-DD") ||
        invoiceCreateDate === 0
      ) {
        toast.warning("Invoice date is invalid!");
        return true;
      }
    }
    let duplicateBillItem;
    const unique = listToCheck.filter((obj, index) => {
      if (
        listToCheck.findIndex(
          (item) =>
            item.name.toLowerCase().trim() === obj.name.toLowerCase().trim()
        ) === index
      ) {
        return obj;
      } else {
        if (obj.isMedicine === "undefined" || !obj.isMedicine) {
          if (obj.isVaccine === "undefined" || !obj.isVaccine) {
            duplicateBillItem = { ...obj };
          }
        }
        return null;
      }
    });

    if (duplicateBillItem && unique.length !== listToCheck.length) {
      toast.warning(
        `Bill item name ${duplicateBillItem.name} cannot be duplicate!`
      );
      return true;
    } else {
      return false;
    }
  }

  function handleAddInvoice(e) {
    if (servicePackageId && validPackageList) {
      setRemainingSessions(
        findRemainingSessions(validPackageList, servicePackageId)
      );
    }

    let check = checkDuplicateBillItem(billArray);
    if (!check) {
      if (
        isConsumePackage &&
        !servicePackageId &&
        ((props?.appointmentId !== null && props?.appointmentId) ||
          props.appointmentInfo !== undefined)
      ) {
        toast.error("Please select service pack to use");
      } else {
        if (
          !isWholeNumber(noOfSessionConsumed) ||
          noOfSessionConsumed > remainingSession
        ) {
          setNoOfSessionsConsumed(1);
          toast.error(
            "consume count should be greater than 0 and  less than or equal to remaining sessions of service pack"
          );
        } else {
          if (props?.isEditInvoiceModal) {
            updateInvoiceHandler();
          } else {
            if (
              props.isGenerateInvoiceWithoutAppointmentModal &&
              selectedClient === "" &&
              !withAppointment
            ) {
              toast.warning("Please select client");
            } else if (
              props.isGenerateInvoiceWithoutAppointmentModal &&
              addressId === "" &&
              !withAppointment
            ) {
              toast.warning("Please select address");
            } else if (
              props.isGenerateInvoiceWithoutAppointmentModal &&
              withAppointment &&
              !selectedAppointment
            ) {
              toast.warning("Please select appointment");
            } else {
              addInvoiceHandler();
            }
          }
        }
      }
    }
    payTabIndexFun(1);
  }

  async function addInvoiceHandler() {
    setIsAddInvoiceLoading(true);
    let billItemList = [];

    for (let obj in billArray) {
      if (
        billArray[obj].name &&
        billArray[obj].qnty &&
        billArray[obj].rate >= 0
      ) {
        billItemList.push({
          amount:
            +billArray[obj].qnty * +billArray[obj].rate
              ? +billArray[obj].qnty * +billArray[obj].rate
              : 0,
          description: billArray[obj].descr ? billArray[obj].descr : "",
          discount: +billArray[obj].discount ? +billArray[obj].discount : 0,
          hsrCode: !billArray[obj].hsrCode
            ? billArray[obj].isMedicalProcedure
              ? billArray[obj]?.medicalProcedureName
              : billArray[obj].name
            : billArray[obj].hsrCode,
          name: billArray[obj].name,
          qnty: +billArray[obj].qnty ? +billArray[obj].qnty : 0,
          rate: +billArray[obj].rate ? +billArray[obj].rate : 0,
          taxRate: +billArray[obj].cgst ? +billArray[obj].sgst : 0,
          cgst: +billArray[obj].cgst ? +billArray[obj].cgst : 0,
          sgst: +billArray[obj].sgst ? +billArray[obj].sgst : 0,
          hsn_sac_code: billArray[obj].hsn_sac_code
            ? billArray[obj].hsn_sac_code
            : "",
          hospitalizationRoomId: +billArray[obj].hospitalizationRoomId
            ? +billArray[obj].hospitalizationRoomId
            : null,
          checkUpIds: billArray[obj].checkUpIds
            ? billArray[obj].checkUpIds
            : [],
          medicineId: billArray[obj].medicineId
            ? billArray[obj].medicineId
            : null,
          medicalProductId: billArray[obj].medicalProductId
            ? billArray[obj].medicalProductId
            : null,
          medicalProductBatchId: billArray[obj].medicalProductBatchId
            ? billArray[obj].medicalProductBatchId
            : null,
          dispensingUnitId: billArray[obj].dispensingUnitId
            ? billArray[obj].dispensingUnitId
            : null,
          isPreSelectedBatch: billArray[obj].isPreSelectedBatch
            ? billArray[obj].isPreSelectedBatch
            : false,
        });
      }
    }

    const hospitalizationRoomIdList = billArray
      .filter((item) => item.hospitalizationId != null)
      .map((item) => item.id);

    const packagePredefinedIdAndDiscountList = packageList.map((item) => {
      const packagePredefinedIdAndDiscountObj = {
        predefined_service_pack_id: item.predefined_service_pack_id,
        discount: parseFloat(item.discount),
        purchaseDate: item.purchaseDate,
      };
      return packagePredefinedIdAndDiscountObj;
    });

    let medicinesIdsToBePaid = [];
    if (listOfMedicinesToBePaid.length > 0) {
      medicinesIdsToBePaid = listOfMedicinesToBePaid.map((item) => {
        return item.id;
      });
    }

    let vaccinesIdsToBePaid = [];
    if (listOfVaccinesToBePaid && listOfVaccinesToBePaid.length > 0) {
      vaccinesIdsToBePaid = listOfVaccinesToBePaid.map((item) => {
        return item.id;
      });
    }

    const reqBody = {
      hospitalizationId: props?.hospitalizationId
        ? props?.hospitalizationId
        : null,
      appointmentId: props.isEditInvoiceModal
        ? props?.generateInvoiceWithoutAppointment
          ? withAppointment
            ? selectedItems[0]
            : null
          : props.appointmentId
        : props?.generateInvoiceWithoutAppointment
        ? withAppointment
          ? selectedItems[0]
          : null
        : props.appointmentInfo?.id,
      clientId: props?.generateInvoiceWithoutAppointment
        ? withAppointment
          ? null
          : selectedClient
        : props?.hospitalizationDetails
        ? props?.hospitalizationDetails?.clientId
        : null,
      consultantId:
        props?.consultantId != null
          ? props?.consultantId
          : props?.hospitalizationDetails
          ? props?.hospitalizationDetails?.consultantId
          : null,
      orgId: props?.orgId != null ? props?.orgId : null,
      billItemsDto: billItemList,
      createDate: invoiceCreateDate,
      dueDate: invoiceDueDate,
      message: "",
      predefined_service_pack_id: packageObj?.id,
      used_service_pack_id:
        isConsumePackage && servicePackageId ? servicePackageId : null,
      servicePackDiscountPct: servicePackDiscount ? +servicePackDiscount : 0,
      packagePredefinedIdAndDiscountList: packagePredefinedIdAndDiscountList,
      teethIdList: pendingMedicalProcedureItemIdList,
      subTreatmentIdList: pendingSubTreatmentItemIdList,
      consumeCount: noOfSessionConsumed === "" ? 1 : noOfSessionConsumed,
      medicineIdList: medicinesIdsToBePaid,
      addressId: addressId,
      vaccinesIdsToBePaid: vaccinesIdsToBePaid,
      hospitalizationRoomIdList: hospitalizationRoomIdList,
    };
    const response = await addInvoiceService(reqBody);

    if (response) {
      toast.success("Invoice generated successfully!");
      navigate(RoutingPaths.PAYMENTS);
      setSelectedClient("");
      setAddressId("");
      setBillArray([]);
      setPackageList([]);
      setValidPackageList([]);
      setNoOfSessionsConsumed(1);

      if (props?.generateInvoiceWithoutAppointment) {
        props.getAllInvoiceList();
        props.setIsGenerateInvoiceWithoutAppointmentModal(false);
        props.setEditInvoiceModal(false);
        setSelectedAppointment("");
        setSelectedItems([]);
      }
      props.onHide();
    }
    setNoOfSessionsConsumed(1);
    setIsAddInvoiceLoading(false);
    setWithAppointment(false);
  }

  async function updateInvoiceHandler() {
    setIsAddInvoiceLoading(true);
    let billItemList = [];
    for (let obj in billArray) {
      if (
        billArray[obj].name &&
        billArray[obj].qnty &&
        billArray[obj].rate >= 0
      ) {
        billItemList.push({
          amount:
            +billArray[obj].qnty * +billArray[obj].rate
              ? +billArray[obj].qnty * +billArray[obj].rate
              : 0,
          description: billArray[obj].descr ? billArray[obj].descr : "",
          discount: +billArray[obj].discount ? +billArray[obj].discount : 0,
          hsrCode: !billArray[obj].hsrCode
            ? billArray[obj].name
            : billArray[obj].hsrCode,
          name: billArray[obj].name,
          qnty: +billArray[obj].qnty ? +billArray[obj].qnty : 0,
          rate: +billArray[obj].rate ? +billArray[obj].rate : 0,
          taxRate: (+billArray[obj]?.cgst || 0) + (+billArray[obj]?.sgst || 0),
          cgst: +billArray[obj].cgst ? +billArray[obj].cgst : 0,
          sgst: +billArray[obj].sgst ? +billArray[obj].sgst : 0,
          hsn_sac_code: billArray[obj].hsn_sac_code
            ? billArray[obj].hsn_sac_code
            : "",
          hospitalizationRoomId: +billArray[obj].hospitalizationRoomId
            ? +billArray[obj].hospitalizationRoomId
            : null,
          checkUpIds: billArray[obj].checkUpIds
            ? billArray[obj].checkUpIds
            : [],
          medicineId: billArray[obj].medicineId
            ? billArray[obj].medicineId
            : null,
          medicalProductId: billArray[obj].medicalProductId
            ? billArray[obj].medicalProductId
            : null,
          medicalProductBatchId: billArray[obj].medicalProductBatchId
            ? billArray[obj].medicalProductBatchId
            : null,
          dispensingUnitId: billArray[obj].dispensingUnitId
            ? billArray[obj].dispensingUnitId
            : null,
          isPreSelectedBatch: billArray[obj].isPreSelectedBatch
            ? billArray[obj].isPreSelectedBatch
            : false,
        });
      }
    }

    const hospitalizationRoomIdList = billArray
      .filter((item) => item.hospitalizationId != null)
      .map((item) => item.id);

    const packagePredefinedIdAndDiscountList = packageList.map((item) => {
      const packagePredefinedIdAndDiscountObj = {
        predefined_service_pack_id: item.predefined_service_pack_id,
        discount: parseFloat(item.discount),
        purchaseDate: item.purchaseDate,
      };
      return packagePredefinedIdAndDiscountObj;
    });

    let medicinesIdsToBePaid = [];
    if (listOfMedicinesToBePaid.length > 0) {
      medicinesIdsToBePaid = listOfMedicinesToBePaid.map((item) => {
        return item.id;
      });
    }

    let vaccinesIdsToBePaid = [];
    if (listOfVaccinesToBePaid && listOfVaccinesToBePaid.length > 0) {
      vaccinesIdsToBePaid = listOfVaccinesToBePaid.map((item) => {
        return item.id;
      });
    }

    const reqBody = {
      hospitalizationId: props?.hospitalizationId
        ? props?.hospitalizationId
        : null,
      id: props?.Invoice?.id,
      appointmentId: props.isEditInvoiceModal
        ? props.appointmentId
        : props.appointmentInfo?.id,
      billItemsDto: billItemList,
      createDate: invoiceCreateDate,
      dueDate: invoiceDueDate,
      message: "",
      predefined_service_pack_id: packageObj?.id,
      used_service_pack_id:
        isConsumePackage && servicePackageId ? servicePackageId : null,
      servicePackDiscountPct: servicePackDiscount ? +servicePackDiscount : 0,
      packagePredefinedIdAndDiscountList: packagePredefinedIdAndDiscountList,
      teethIdList: pendingMedicalProcedureItemIdList,
      subTreatmentIdList: pendingSubTreatmentItemIdList,
      consumeCount: noOfSessionConsumed === "" ? 1 : noOfSessionConsumed,
      medicineIdList: medicinesIdsToBePaid,
      vaccinesIdsToBePaid: vaccinesIdsToBePaid,
      hospitalizationRoomIdList: hospitalizationRoomIdList,
    };
    const response = await updateInvoiceService(reqBody);
    if (response) {
      toast.success("Invoice Updated successfully!");
      setIsSelectBillCode(true);
      setBillCodeList([]);
      setRowNoToGenerateDropdown("");
      setInvoiceDueDate(new Date().getTime());
      setPackageObj();
      setTotal();
      setServicePackageId("");
      setPackageList([]);
      setValidPackageList([]);
      setServicePackDiscount();
      setIsConsumePackage(false);
      setNoOfSessionsConsumed(1);

      props.getAllInvoiceList();
      props.onHide();
      props.setEditInvoiceModal(false);
      props.setInvoice({});
      props.setAppointmentId("");
      setSelectedClient("");
      setAddressId("");
      props.setIsGenerateInvoiceWithoutAppointmentModal(false);
      navigate(RoutingPaths.PAYMENTS);
    } else {
      setValidPackageList([]);
      setBillArray(tempBillArray);
      setPackageObj("");
      setPackageList([]);
      getBillCodesInfo();
      setSelectedClient("");
      setAddressId("");
      setServicePackageId("");
      setIsConsumePackage(false);
      setNoOfSessionsConsumed(1);
    }
    setIsAddInvoiceLoading(false);
  }

  function handleChangeServicePack(e, packItem, index) {
    const updatedPackageList = packageList.map((item, i) =>
      packItem.id === item.id && i === index
        ? {
            ...item,
            discount: e.target.value,
            amount:
              packItem.rate *
              packItem.qnty *
              ((100 + +packItem.taxRate) / 100) *
              ((100 - +e.target.value) / 100),
          }
        : item
    );

    if (packItem.id === servicePackageId) {
      setServicePackageId("");
      setIsConsumePackage(false);
    }
    calculateTotalSubtotal(billArray, updatedPackageList);

    setPackageList(updatedPackageList);
  }

  function handleChange(e, i, value = null) {
    setRowNoToGenerateDropdown(i);
    let array = [...billArray];
    let numericInput;
    if (
      e.target.name === "descr" ||
      e.target.name === "name" ||
      e.target.name === "hsn_sac_code"
    ) {
      numericInput = e.target.value;
    } else if (!value) {
      numericInput = e.target.value.replace(/[^0-9.]/g, "");
    }
    value
      ? (array[i] = { ...value, qnty: 1, discount: 0 })
      : (array[i] = { ...array[i], [e.target.name]: numericInput });

    if (
      (e.target.name === "descr" ||
        e.target.name === "qnty" ||
        e.target.name === "rate" ||
        e.target.name === "taxRate") &&
      billArray[i].name !== "" &&
      !array[i].medicalProductBatchId
    ) {
      checkIsBillItemNew(i, array[i]);
    }

    const qty = +array[i].qnty;
    const rate = +array[i].rate;
    const tax = +array[i].cgst + +array[i].sgst;

    if (e.target.name === "amount") {
      const amount = +array[i].amount;
      // Calculate discount

      let denominator = qty * rate * (100 + tax);
      let fraction = (100 * amount) / denominator;
      const calculatedDiscount = 100 - fraction * 100;

      array[i] = {
        ...array[i],
        discount:
          calculatedDiscount <= 0 || isNaN(calculatedDiscount)
            ? 0
            : parseFloat(calculatedDiscount).toFixed(2),
      };
    } else {
      // Calculate amount
      const discount = +array[i].discount;

      const amount =
        (qty * rate * ((100 - discount) / 100) * (100 + tax)) / 100;

      array[i] = {
        ...array[i],
        amount: isNaN(amount) ? 0 : parseFloat(amount).toFixed(2),
      };
    }

    setBillArray(array);
  }

  function calculateTotalSubtotal(billList, packageList) {
    let subtotal = 0;
    billList.map((item) => (subtotal += +item.amount));
    calculateTotal(billList, packageList);
  }

  function calculateTotal(array, packageList) {
    let amount = 0;
    let discountVal = 0;
    let taxVal = 0;
    let SubTotal = 0;
    let billArrayTotal = 0;
    array.map((item, i) => {
      amount = +item.rate * +item.qnty;
      SubTotal += amount;

      let discount = item.discount ? item.discount : 0;
      let discountedAmount = (amount * +discount) / 100;
      discountVal += discountedAmount;
      let tax = (+item.cgst || 0) + (+item.sgst || 0);
      taxVal += ((+amount - +discountedAmount) * +tax) / 100;
      return null;
    });
    billArrayTotal = SubTotal - discountVal + taxVal;

    if (packageList && packageList.length > 0) {
      let packTotal = 0;
      for (let index = 0; index < packageList.length; index++) {
        packTotal += packageList[index]?.amount;
      }

      let totalAmount = billArrayTotal + packTotal;
      setTotal(totalAmount);
    } else {
      setTotal(SubTotal - discountVal + taxVal);
    }
  }

  function handleCancel() {
    let defaultBillCodes = billCodeListResponse.filter(
      (billCode) => billCode.hsrCode === "default"
    );

    let array = defaultBillCodes.map((billCode) => {
      return {
        ...billCode,
        qnty: 1,
        amount: billCode.rate * ((100 + billCode.taxRate) / 100),
      };
    });
    calculateTotalSubtotal(array);
    setBillArray(array);
    setIsAddInvoiceLoading(false);
    setIsSelectBillCode(true);
    setBillCodeList([]);
    setRowNoToGenerateDropdown("");
    setInvoiceDueDate(new Date().getTime());
    setPackageObj();
    setTotal();
    setServicePackageId();
    setIsConsumePackage(false);
    setPackageList([]);
    setValidPackageList([]);
    setServicePackDiscount();
    setPackageList([]);
    setNewPackList([]);
    setPendingMedicalProcedureToothNoList([]);
    setNoOfSessionsConsumed(1);

    setPendingSubTreatmentItemIdList([]);
    setPendingSubTreatmentItemList([]);
    setPendingMedicalProcedureItemIdList([]);
    setSelectedMedicalProductList([]);
    setMedicalProductBillCodeList([]);
    if (
      props?.isGenerateInvoiceWithoutAppointmentModal ||
      (!props.appointmentInfo && !props?.hospitalizationDetails)
    ) {
      props.setIsGenerateInvoiceWithoutAppointmentModal(false);
      props.setEditInvoiceModal(false);
      props.setInvoice({});
      props.setAppointmentId("");
      setSelectedAppointment("");
      setSelectedItems([]);
    }
    setWithAppointment(false);
    setSelectedClient("");
    setAddressId("");
    setBillArray(array);
    setShowMedicalBillCodes(false);
    props.onHide();
  }

  function handleCallMedicalProductBillCodes() {
    if (selectedMedicalProductList) {
      getMedicalProductBillCodeListByHandler();
    }
    setShowMedicalBillCodes(true);
  }

  function handleCancelSelectMedicalProduct() {
    setSelectedMedicalProductList([]);
    setHideSelectMedicalProduct(!hideSelectMedicalProduct);
    setShowMedicalBillCodes(false);
  }

  function handleBackToSelectMedicalProduct() {
    setShowMedicalBillCodes(false);
  }

  function toggleAddBillCodeModal() {
    setStartAddBillCodeModal(!startAddBillCodeModal);
  }

  async function getUpdatedList(updatedItem, i) {
    const response = await getBillCodes();
    if (response.length) {
      setBillCodeListResponse(response);
    }
    let array = [...billArray];
    array[i] = {
      ...updatedItem,
      qnty: 1,
      discount: "",
      amount: updatedItem.rate * ((100 + updatedItem.taxRate) / 100),
    };
    setBillArray(array);
    calculateTotalSubtotal(array, packageList);
  }

  function handleModalClose(i) {
    let array = [...billArray];
    array[i] = { ...array[i], modalClosedForRow: true };
    setBillArray(array);
  }

  function checkIsBillItemNew(i, itemToSave) {
    let newBillItem = billCodeListResponse.filter(
      (billCode) =>
        billCode.name.toLowerCase() === billArray[i].name.toLowerCase().trim()
    );
    const dentalProcedure = pendingMedicalProcedureToothNoList.filter(
      (item) =>
        `${item?.toothNumber} - ${item?.treatmentName}` === itemToSave.hsrCode
    );
    const nonDentalProcedure = pendingSubTreatmentItemList.filter(
      (item) =>
        `${item?.subTreatmentName} - ${item?.treatmentName}` ===
        itemToSave.hsrCode
    );
    const isMedicalProcedure =
      dentalProcedure?.length !== 0 ||
      nonDentalProcedure.length !== 0 ||
      itemToSave?.isMedicalProcedure
        ? true
        : false;

    if (
      newBillItem.length === 0 &&
      (!billArray[i]?.modalClosedForRow ?? true) &&
      !isMedicalProcedure &&
      !billArray[i].isMedicine &&
      !billArray[i].isVaccine
    ) {
      SetIndexOfNewBillItem(i);
      setBillItemToSave({ ...itemToSave });
      toggleAddBillCodeModal();
    }
  }

  let timer;
  const debouncedFunction = (e) => {
    clearTimeout(timer);
    if (!e.target.value) {
      setIsSelectBillCode(false);
      setBillCodeList([]);
    }
    timer = setTimeout(() => {
      const filtered = billCodeListResponse.filter((item) => {
        return item.name.toLowerCase().includes(e.target.value.toLowerCase());
      });
      setBillCodeList(filtered);
    }, delay);
  };

  function toggleBuyPackageModal() {
    setIsBuyPackageModal(!isBuyPackageModal);
  }

  function updateSubtotalTotalForPackage(packageObj) {
    const packageAsBillItem = {
      name: packageObj.name,
      descr: packageObj.description,
      qnty: "1",
      cgst: packageObj.cgst,
      sgst: packageObj.sgst,
      hsn_sac_code: packageObj?.hsn_sac_code ? packageObj.hsn_sac_code : " ",
      taxRate: packageObj.cgst + packageObj.sgst,
      rate: packageObj.subTotal,
      amount: packageObj.totalPrice,
      purchaseDate: packageObj.purchaseDate,
      newPackage: true,
      discount: packageObj.discount,
      predefined_service_pack_id: packageObj.id,
    };
    setPackageList((prevPackageList) => [
      ...prevPackageList,
      packageAsBillItem,
    ]);

    calculateTotalSubtotal(billArray, [...packageList, packageAsBillItem]);

    setValidPackageList((validPackageList) => [
      ...validPackageList,
      packageObj,
    ]);

    setPackageObj(packageObj);
    setServicePackDiscount(packageObj.discount);
  }

  const formatTotal = (total) => {
    const parsedTotal = parseFloat(total);
    return isNaN(parsedTotal)
      ? parseFloat(0).toFixed(2)
      : parsedTotal.toFixed(2);
  };

  const findPackageById = (packageList, packageId) => {
    const packageObj = packageList.find((pack) => pack.id === packageId);
    if (packageObj) {
      return packageObj;
    }
    return "";
  };

  const handleInputChange = (newValue) => {
    setSearchClient(newValue);
  };

  function handleChangeInvoiceGeneration(e) {
    setWithAppointment(e.target.value === "true" ? true : false);
  }

  function toggleSelectAppointmentModal() {
    setIsSelectAppointmentModal(!isSelectAppointmentModal);
  }

  const findRemainingSessions = (packageList, packageId) => {
    const packageObj = packageList.find((pack) => pack.id === packageId);
    if (packageObj) {
      return packageObj?.remainingSession
        ? packageObj?.remainingSession
        : packageObj?.numSessions;
    }
    return "";
  };

  function handleConsumeCount(e) {
    const consumeCountVal = e.target.value.replace(/[^0-9.]/g, "");

    if (
      /^\d*$/.test(consumeCountVal) &&
      consumeCountVal !== "-" &&
      consumeCountVal !== "+" &&
      consumeCountVal < maxInteger
    ) {
      setNoOfSessionsConsumed(consumeCountVal);
    } else {
      setNoOfSessionsConsumed(1);
    }
  }

  const isWholeNumber = (value) => {
    if (value === "") {
      value = 1;
    }
    return Number.isInteger(Number(value)) && Number(value) >= 1;
  };

  async function getAddressListAPIHandler() {
    try {
      const response = await getAddressListAPI();
      if (response && response.length > 0) {
        const optionList = response.map((item) => {
          return {
            label: `${item.addressLine1}`,
            value: `${item.addressLine1}`,
            id: item.id,
          };
        });
        setOrgAddressList(optionList);
      }
    } catch (error) {
      setOrgAddressList([]);
    }
  }

  async function getPrescriptionByAppointmentIdHandler() {
    setIsPrescriptionLoading(true);

    const response = await getPrescriptionByAppointmentId(appointmentId);

    if (response) {
      const inventoryMedicines = response.prescription?.medicine
        ?.filter((medicine) => medicine.isFromInventory === true)
        .map((medicine) => ({
          name: medicine.name,
          strength: medicine.strength,
          form: medicine.form,
          quantity: medicine.quantity,
          id: medicine.id,
          type: medicine.type,
          timing: medicine.timing,
          dosage: medicine.dosage,
          numberOfDays: medicine.numberOfDays,
          comment: medicine.comment,
          unitCost: medicine.unitCost,
          totalCost: medicine.totalCost,
          isIncludedInInvoice: medicine.isIncludedInInvoice,
          isMedicinePaid: medicine.isMedicinePaid,
          medicalProductId: medicine.medicalProductId,
          medicalProductDtos: medicine.medicalProductDtos,
          isFromInventory: medicine.isFromInventory,
          quantityPerDosage: medicine.quantityPerDosage,
          dosageQntyUnitId: medicine.dosageQntyUnitId,
          dispensingUnitId: medicine.dosageQntyUnitId
            ? medicine.dosageQntyUnitId
            : null,
        }));

      setMedicineList(inventoryMedicines || []);
    } else {
      setMedicineList([]);
      setHideSelectMedicalProduct(false);
    }

    setIsPrescriptionLoading(false);
  }

  async function getMedicalProductListByMedicineHandler() {
    setIsMedicalProductListLoading(true);

    const response = await getMedicalProductListByMedicine(medicineList);

    if (response) {
      if (
        props.isEditInvoiceModal ||
        props?.generateInvoiceWithoutAppointment
      ) {
        setHideSelectMedicalProduct(false);
      } else {
        setHideSelectMedicalProduct(true);
      }

      setMedicalProductList(response.data);
    }

    setIsMedicalProductListLoading(false);
  }

  async function getMedicalProductBillCodeListByHandler() {
    setIsMedicalProductBillCodeListLoading(true);

    const response = await getMedicalProductBillCodes(
      selectedMedicalProductList
    );

    if (response?.data) {
      const medicalProductBillCodes = response?.data?.availableBillCodes;

      if (medicalProductBillCodes && medicalProductBillCodes.length === 0) {
        setMedicalProductBillCodeList([]);
      }

      setMedicalProductBillCodeList(response.data);
    } else {
      setMedicalProductBillCodeList(response);
    }

    setIsMedicalProductBillCodeListLoading(false);
  }

  function handleHideSelectMedicalProduct() {
    const medicalProductBillCodes =
      medicalProductBillCodeList.availableBillCodes;
    let tempBillList = [];

    for (let i = 0; i < medicalProductBillCodes?.length; i++) {
      const obj = {
        name: `${medicalProductBillCodes[i]?.name} `,
        descr: medicalProductBillCodes[i]?.name,
        qnty: medicalProductBillCodes[i]?.quantity,
        taxRate: 0,
        discount: 0,
        rate: medicalProductBillCodes[i]?.rate,
        amount: medicalProductBillCodes[i]?.amount,
        isMedicine: true,
        medicineId: medicalProductBillCodes[i]?.medicineId,
        medicalProductId: medicalProductBillCodes[i]?.medicalProductId,
        medicalProductBatchId:
          medicalProductBillCodes[i]?.medicalProductBatchId,
        medicineName: `${medicalProductBillCodes[i]?.name}`,
        dispensingUnitId: medicalProductBillCodes[i]?.dispensingUnitId,
        isPreSelectedBatch: medicalProductBillCodes[i]?.isPreSelectedBatch,
        cgst: medicalProductBillCodes[i]?.cgst,
        sgst: medicalProductBillCodes[i]?.sgst,
        hsn_sac_code: medicalProductBillCodes[i]?.hsn_sac_code,
      };
      tempBillList = [...tempBillList, obj];
    }

    const updatedBillList = tempBillList;

    const newBillArray = billArray.filter((existingItem) => {
      if (
        existingItem.medicalProductId === undefined ||
        existingItem.medicalProductBatchId === undefined ||
        existingItem.medicalProductId === null ||
        existingItem.medicalProductBatchId === null ||
        existingItem.medicineId === null ||
        existingItem.medicineId === null
      ) {
        return true;
      }

      const itemInUpdatedList = updatedBillList.some(
        (updatedItem) =>
          updatedItem.medicalProductId === existingItem.medicalProductId &&
          updatedItem.medicalProductBatchId ===
            existingItem.medicalProductBatchId &&
          updatedItem.medicineId === existingItem.medicineId
      );

      return itemInUpdatedList;
    });

    updatedBillList.forEach((updatedItem) => {
      const existingItemIndex = newBillArray.findIndex(
        (existingItem) =>
          existingItem.medicalProductId === updatedItem.medicalProductId &&
          existingItem.medicalProductBatchId ===
            updatedItem.medicalProductBatchId &&
          existingItem.medicineId === updatedItem.medicineId
      );

      if (existingItemIndex !== -1) {
        const existingItem = newBillArray[existingItemIndex];

        if (existingItem.qnty !== updatedItem.qnty) {
          newBillArray[existingItemIndex] = {
            ...existingItem,
            qnty: updatedItem.qnty,
            amount: updatedItem.amount,
            rate: updatedItem.rate,
          };
        }
      } else {
        newBillArray.push(updatedItem);
      }
    });

    setBillArray(newBillArray);
    setHideSelectMedicalProduct(!hideSelectMedicalProduct);
    setShowMedicalBillCodes(!showMedicalBillCodes);
  }

  function handleShowSelectMedicalProduct() {
    if (props.show) {
      const selectedProducts = [];
      const productMap = new Map();

      billArray.forEach((billItem) => {
        const medicalProduct = medicalProductList.find(
          (product) => product.id === billItem.medicineId
        );

        if (medicalProduct) {
          const matchedDto = medicalProduct.medicalProductDtos.find(
            (dto) => dto.id === billItem.medicalProductId
          );

          if (!matchedDto) return;

          const mapKey = `${billItem.medicineId}-${billItem.medicalProductId}`;

          const billCodes = billArray
            .filter(
              (item) =>
                item.medicineId === billItem.medicineId &&
                item.medicalProductId === billItem.medicalProductId
            )
            .map((item) => ({
              batchId: item.medicalProductBatchId,
              quantity: item.qnty,
              dispensingUnitId: item.dispensingUnitId,
            }));

          if (productMap.has(mapKey)) {
            const existingProduct = productMap.get(mapKey);
            existingProduct.newQuantity += billItem.qnty;
            existingProduct.quantity += billItem.qnty;
            existingProduct.dispensingUnitId = billItem.dispensingUnitId;
          } else {
            productMap.set(mapKey, {
              ...medicalProduct,
              medicineId: billItem.medicineId,
              medicalProductId: billItem.medicalProductId,
              newQuantity: billItem.qnty,
              quantity: billItem.qnty,
              dispensingUnitId: billItem.dispensingUnitId,
              billCodes: billCodes,
              medicalProductBatches: billCodes.map((bc) => bc.batchId),
            });
          }

          if (props.isEditInvoiceModal) {
            const product = productMap.get(mapKey);

            const existingBillCode = product.billCodes.find(
              (billCode) => billCode.batchId === billItem.medicalProductBatchId
            );

            const isBatchIdInBillItemsDto = props?.Invoice?.billItemsDto?.some(
              (item) =>
                item.medicalProductBatchId === billItem.medicalProductBatchId
            );

            if (!existingBillCode && isBatchIdInBillItemsDto) {
              product.billCodes.push({
                batchId: billItem.medicalProductBatchId,
                quantity: billItem.qnty,
                dispensingUnitId: billItem.dispensingUnitId,
              });
            }
          }
        }
      });

      productMap.forEach((product) => {
        const updatedProductDtos = product.medicalProductDtos.map((dto) => {
          const billCode = product.billCodes.find(
            (code) => code.batchId === dto.id
          );

          if (billCode) {
            return {
              ...dto,
              billCode: billCode.quantity,
            };
          }
          return dto;
        });

        selectedProducts.push({
          ...product,
          medicineId: product.medicineId,
          medicalProductDtos: updatedProductDtos,
        });
      });

      setSelectedMedicalProductList(selectedProducts);
    }

    setMedicalProductBillCodeList([]);
    setHideSelectMedicalProduct(!hideSelectMedicalProduct);
    setShowMedicalBillCodes(false);
  }

  const handleDtoCheckboxChange = (e, product, dto) => {
    const checked = e.target.checked;

    const updatedProduct = {
      ...product,
      medicineId: product.id,
      medicalProductId: dto.id,
    };
    const fieldErrorKey = `${product.id}-${dto.id}`;
    setSelectedMedicalProductList((prevSelected) => {
      const match = (item) =>
        item.medicineId === updatedProduct.medicineId &&
        item.medicalProductId === updatedProduct.medicalProductId;

      if (checked) {
        if (!prevSelected.some(match)) {
          return [...prevSelected, updatedProduct];
        }
      } else {
        setFieldErrors((prev) => {
          const updated = { ...prev };
          delete updated[fieldErrorKey];
          return updated;
        });

        return prevSelected.filter((item) => !match(item));
      }

      return prevSelected;
    });
  };

  const handleUpdateQuantity = (dto, newQuantity, productIndex) => {
    const updatedProductList = [...medicalProductList];

    const productToUpdate = updatedProductList[productIndex];
    const dtoToUpdate = productToUpdate.medicalProductDtos.find(
      (item) => item.id === dto.id
    );
    dtoToUpdate.newQuantity = newQuantity;

    setMedicalProductList(updatedProductList);

    const updatedSelectedProductList = [...selectedMedicalProductList];

    const selectedProductToUpdate = updatedSelectedProductList.find(
      (item) =>
        item.medicalProductId === dto.id &&
        item.medicineId === medicalProductList[productIndex].id
    );

    if (selectedProductToUpdate) {
      const selectedDtoToUpdate =
        selectedProductToUpdate.medicalProductDtos.find(
          (item) => item.id === dto.id
        );

      if (selectedDtoToUpdate) {
        selectedProductToUpdate.quantity = newQuantity;
      } else {
        console.error("Matching dto not found in selectedProductToUpdate");
      }
    } else {
      updatedSelectedProductList.push({
        ...selectedProductToUpdate,
        medicineId: medicalProductList[productIndex].id,
        quantity: newQuantity,
      });
    }

    const uniqueSelectedMedicalProductList = updatedSelectedProductList.filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) =>
            t.medicalProductId === value.medicalProductId &&
            t.medicineId === value.medicineId
        )
    );

    setSelectedMedicalProductList(uniqueSelectedMedicalProductList);
  };

  const handleUpdateUnit = (dto, newUnitId, productIndex) => {
    const updatedProductList = [...medicalProductList];
    const productToUpdate = updatedProductList[productIndex];
    const dtoToUpdate = productToUpdate.medicalProductDtos.find(
      (item) => item.id === dto.id
    );
    if (dtoToUpdate) {
      dtoToUpdate.newUnitId = newUnitId;
    }

    const updatedSelectedProductList = [...selectedMedicalProductList];
    const selectedProductToUpdate = updatedSelectedProductList.find(
      (item) =>
        item.medicalProductId === dto.id &&
        item.medicineId === medicalProductList[productIndex].id
    );

    if (selectedProductToUpdate) {
      selectedProductToUpdate.dispensingUnitId = newUnitId;
    } else {
      updatedSelectedProductList.push({
        ...dto,
        medicineId: medicalProductList[productIndex].id,
        dispensingUnitId: newUnitId,
      });
    }

    const uniqueSelectedMedicalProductList = updatedSelectedProductList.filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) =>
            t.medicalProductId === value.medicalProductId &&
            t.medicineId === value.medicineId
        )
    );

    setSelectedMedicalProductList(uniqueSelectedMedicalProductList);
  };

  const handleBatchCheckboxChange = (batchKey, batchId, checked) => {
    setSelectedBatchMap((prev) => {
      const prevSelected = prev[batchKey] || [];
      let updated;
      if (checked) {
        updated = [...prevSelected, batchId];
      } else {
        updated = prevSelected.filter((id) => id !== batchId);
      }
      return {
        ...prev,
        [batchKey]: updated,
      };
    });
  };

  const hasFieldErrors = () => {
    return Object.values(fieldErrors).some(
      (error) => error.quantity || error.unit
    );
  };

  async function fetchContentMeasurementUnitMedicalProduct(
    medicalProductId,
    batchKey
  ) {
    const response = await getContentMeasurementUnitMedicalProduct(
      medicalProductId
    );

    if (response && response.data) {
      setContentMeasurementUnitList((prev) => ({
        ...prev,
        [batchKey]: response.data.data,
      }));
    } else {
      setContentMeasurementUnitList((prev) => ({
        ...prev,
        [batchKey]: [],
      }));
    }
  }

  return (
    <div>
      <Modal
        size={isBillWithGst ? "xl" : "lg"}
        centered
        show={props.show}
        // onHide={props.onHide}
        dialogClassName="Invoice-modal"
      >
        -
        <ModalBody>
          {!isConsultantUser &&
          organizationDto?.isMedicalInventory &&
          hideSelectMedicalProduct ? (
            <>
              {showMedicalBillCodes === false && (
                <>
                  <h5 className="mt-2 ">Select Medical Product</h5>

                  <div
                    className="checklist p-2 d-flex justify-content-between mb-2"
                    style={{
                      minHeight: "200px",
                      maxHeight: "400px",
                      height: "auto",
                      overflowY: "auto",
                    }}
                  >
                    {medicalProductList?.length === 0 ? (
                      <span>Medical Products not available</span>
                    ) : (
                      <div
                        className="list mb-4"
                        style={{
                          width: "100%",
                        }}
                      >
                        {medicalProductList?.map((product, index) => {
                          return (
                            <Fragment key={`product-${product.name}-${index}`}>
                              <div
                                key={`product-${product.name}-${index}`}
                                className={`mb-2 product-div `}
                              >
                                <h6>
                                  <span className="fw-bold">
                                    {" "}
                                    {product.name}{" "}
                                  </span>{" "}
                                  ( Required Qty: {"  "}
                                  {product.quantity} )
                                </h6>

                                {product.medicalProductDtos.length > 0 ? (
                                  <div>
                                    {product.medicalProductDtos.map(
                                      (dto, dtoIndex) => {
                                        const isChecked =
                                          selectedMedicalProductList.some(
                                            (item) =>
                                              item.medicalProductId ===
                                                dto.id &&
                                              item.medicineId === product.id
                                          );

                                        const selectedItem =
                                          selectedMedicalProductList.find(
                                            (item) =>
                                              item.medicalProductId ===
                                                dto.id &&
                                              item.medicineId === product.id
                                          );

                                        const defaultQuantity = selectedItem
                                          ? selectedItem.quantity
                                            ? selectedItem.quantity
                                            : product.quantity
                                          : "";

                                        let defaultUnitId;

                                        const selectedUnitId =
                                          selectedItem?.dispensingUnitId
                                            ? Number(
                                                selectedItem.dispensingUnitId
                                              )
                                            : undefined;

                                        const productUnitId =
                                          product.dosageQntyUnitId
                                            ? Number(product.dosageQntyUnitId)
                                            : undefined;

                                        const dtoUnitId = dto.dispenseUnitId;

                                        const isSelectedItemUnitValid =
                                          dto.allDispensingUnits?.some(
                                            (unit) => unit.id === selectedUnitId
                                          );

                                        const isProductDosageUnitValid =
                                          dto.allDispensingUnits?.some(
                                            (unit) => unit.id === productUnitId
                                          );

                                        if (isSelectedItemUnitValid) {
                                          defaultUnitId = selectedUnitId;
                                        } else if (isProductDosageUnitValid) {
                                          defaultUnitId = productUnitId;
                                        } else {
                                          defaultUnitId = dtoUnitId;
                                        }

                                        if (
                                          selectedItem &&
                                          selectedItem.dispensingUnitId !==
                                            defaultUnitId
                                        ) {
                                          handleUpdateUnit(
                                            dto,
                                            defaultUnitId,
                                            index
                                          );
                                        }

                                        const batchKey = `${product.id}-${dto.id}`;
                                        const suggestedBatchesRaw =
                                          typeof suggestedMedicalProductBatchList ===
                                          "object"
                                            ? suggestedMedicalProductBatchList[
                                                batchKey
                                              ]
                                            : undefined;

                                        const suggestedBatches = Array.isArray(
                                          suggestedBatchesRaw
                                        )
                                          ? suggestedBatchesRaw
                                          : [];

                                        const selectedItemInList =
                                          selectedMedicalProductList.find(
                                            (item) =>
                                              item.medicineId === product.id &&
                                              item.medicalProductId === dto.id
                                          );
                                        const selectedBatchIds =
                                          selectedItemInList &&
                                          Array.isArray(
                                            selectedItemInList.medicalProductBatches
                                          )
                                            ? selectedItemInList.medicalProductBatches
                                            : (typeof selectedBatchMap ===
                                                "object" &&
                                                selectedBatchMap[batchKey]) ||
                                              [];

                                        if (
                                          selectedItem &&
                                          (!contentMeasurementUnitList ||
                                            !Array.isArray(
                                              contentMeasurementUnitList[
                                                batchKey
                                              ]
                                            ))
                                        ) {
                                          if (selectedItem.medicalProductId) {
                                            fetchContentMeasurementUnitMedicalProduct(
                                              selectedItem.medicalProductId,
                                              batchKey
                                            );
                                          }
                                        }

                                        if (
                                          selectedItem &&
                                          (!suggestedMedicalProductBatchList ||
                                            !Array.isArray(
                                              suggestedMedicalProductBatchList[
                                                batchKey
                                              ]
                                            ))
                                        ) {
                                          if (
                                            props?.Invoice
                                              ?.productIdToBatchPairMap &&
                                            props?.Invoice
                                              ?.productIdToBatchPairMap[
                                              selectedItem.medicalProductId
                                            ]
                                          ) {
                                            setSuggestedMedicalProductBatchList(
                                              (prev) => ({
                                                ...prev,
                                                [batchKey]: [],
                                              })
                                            );

                                            const batchBillItems =
                                              props.Invoice
                                                .productIdToBatchPairMap[
                                                selectedItem.medicalProductId
                                              ];

                                            getSuggestedMedicalProductBatches(
                                              selectedItem.medicalProductId,
                                              selectedItem.numberOfDays,
                                              "",
                                              batchBillItems
                                            ).then((response) => {
                                              if (response && response.data) {
                                                setSuggestedMedicalProductBatchList(
                                                  (prev) => ({
                                                    ...prev,
                                                    [batchKey]:
                                                      response.data.data,
                                                  })
                                                );
                                              } else {
                                                setSuggestedMedicalProductBatchList(
                                                  (prev) => ({
                                                    ...prev,
                                                    [batchKey]: [],
                                                  })
                                                );
                                              }
                                            });
                                          } else {
                                            getSuggestedMedicalProductBatches(
                                              selectedItem.medicalProductId,
                                              selectedItem.numberOfDays,
                                              ""
                                            ).then((response) => {
                                              if (response && response.data) {
                                                setSuggestedMedicalProductBatchList(
                                                  (prev) => ({
                                                    ...prev,
                                                    [batchKey]:
                                                      response.data.data,
                                                  })
                                                );
                                              } else {
                                                setSuggestedMedicalProductBatchList(
                                                  (prev) => ({
                                                    ...prev,
                                                    [batchKey]: [],
                                                  })
                                                );
                                              }
                                            });
                                          }
                                        }

                                        if (
                                          selectedItem &&
                                          Array.isArray(
                                            selectedItem.billCodes
                                          ) &&
                                          suggestedBatches.length > 0
                                        ) {
                                          const batchKey = `${product.id}-${dto.id}`;
                                          const previouslySelectedBatchIds =
                                            selectedItem.billCodes.map(
                                              (billCode) => billCode.batchId
                                            );

                                          if (
                                            !selectedBatchMap.hasOwnProperty(
                                              batchKey
                                            )
                                          ) {
                                            setSelectedBatchMap((prev) => ({
                                              ...prev,
                                              [batchKey]:
                                                previouslySelectedBatchIds,
                                            }));

                                            setSelectedMedicalProductList(
                                              (prevSelected) =>
                                                prevSelected.map((item) =>
                                                  item.medicineId ===
                                                    product.id &&
                                                  item.medicalProductId ===
                                                    dto.id
                                                    ? {
                                                        ...item,
                                                        medicalProductBatches:
                                                          previouslySelectedBatchIds,
                                                      }
                                                    : item
                                                )
                                            );
                                          }
                                        }
                                        return (
                                          <Fragment
                                            key={`product-${index}-dto-${dtoIndex}`}
                                          >
                                            <div
                                              className={`dto-div ${
                                                selectedMedicalProductList.some(
                                                  (item) =>
                                                    item.medicalProductId ===
                                                      dto.id &&
                                                    item.medicineId ===
                                                      product.id
                                                )
                                                  ? "selected"
                                                  : ""
                                              }`}
                                              style={{
                                                width: "100%",
                                                maxWidth: "100%",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                id={`product-${index}-dto-${dtoIndex}`}
                                                value={dto.id}
                                                checked={isChecked}
                                                onChange={(e) => {
                                                  handleDtoCheckboxChange(
                                                    e,
                                                    product,
                                                    dto
                                                  );

                                                  if (e.target.checked) {
                                                    if (
                                                      !suggestedBatches.length
                                                    ) {
                                                      getSuggestedMedicalProductBatches(
                                                        dto.id,
                                                        product.numberOfDays,
                                                        ""
                                                      ).then((response) => {
                                                        if (
                                                          response &&
                                                          response.data
                                                        ) {
                                                          setSuggestedMedicalProductBatchList(
                                                            (prev) => ({
                                                              ...prev,
                                                              [batchKey]:
                                                                response.data
                                                                  .data,
                                                            })
                                                          );
                                                        } else {
                                                          setSuggestedMedicalProductBatchList(
                                                            (prev) => ({
                                                              ...prev,
                                                              [batchKey]: [],
                                                            })
                                                          );
                                                        }
                                                      });
                                                    }
                                                  } else {
                                                    setSelectedBatchMap(
                                                      (prev) => ({
                                                        ...prev,
                                                        [batchKey]: [],
                                                      })
                                                    );

                                                    setSelectedMedicalProductList(
                                                      (prevSelected) =>
                                                        prevSelected.map(
                                                          (item) =>
                                                            item.medicineId ===
                                                              product.id &&
                                                            item.medicalProductId ===
                                                              dto.id
                                                              ? {
                                                                  ...item,
                                                                  medicalProductBatches:
                                                                    [],
                                                                }
                                                              : item
                                                        )
                                                    );
                                                  }
                                                }}
                                              />

                                              <span
                                                htmlFor={`product-${index}-dto-${dtoIndex}`}
                                                className="ms-2"
                                                style={{
                                                  width: "100%",
                                                  maxWidth: "100%",
                                                }}
                                              >
                                                <p className="mb-0">
                                                  <span className="fw-bold me-2">
                                                    {" "}
                                                    {dto.name} -{" "}
                                                    {dto.composition}
                                                  </span>
                                                  ({" "}
                                                  <span>
                                                    Available Qty: {"  "}{" "}
                                                  </span>
                                                  <span>
                                                    {dto.currentQuantityDisplay}
                                                  </span>{" "}
                                                  )
                                                </p>

                                                <span>{dto.manufacturer}</span>

                                                {isChecked && (
                                                  <>
                                                    {contentMeasurementUnitList &&
                                                      Array.isArray(
                                                        contentMeasurementUnitList[
                                                          `${product.id}-${dto.id}`
                                                        ]
                                                      ) &&
                                                      contentMeasurementUnitList[
                                                        `${product.id}-${dto.id}`
                                                      ].length > 0 && (
                                                        <Accordion
                                                          style={{
                                                            padding: 0,
                                                            marginTop: "1em",
                                                          }}
                                                        >
                                                          <Accordion.Item eventKey="0">
                                                            <Accordion.Header
                                                              style={{
                                                                padding: 0,
                                                                margin: 0,
                                                                "--bs-accordion-btn-padding-x":
                                                                  "0.5rem",
                                                                "--bs-accordion-btn-padding-y":
                                                                  "0.5rem",
                                                              }}
                                                            >
                                                              Product contains
                                                            </Accordion.Header>
                                                            <Accordion.Body className="d-flex gap-2 flex-wrap">
                                                              {contentMeasurementUnitList[
                                                                `${product.id}-${dto.id}`
                                                              ].map(
                                                                (unit, idx) => (
                                                                  <div
                                                                    key={idx}
                                                                    className="mb-2 p-2 border rounded"
                                                                  >
                                                                    <div>
                                                                      <span className="fw-bold">
                                                                        {
                                                                          unit.conversionFactorDisplay
                                                                        }
                                                                      </span>
                                                                    </div>
                                                                    <div>
                                                                      Batch
                                                                      Numbers:{" "}
                                                                      {Array.isArray(
                                                                        unit.batchNumbers
                                                                      )
                                                                        ? unit.batchNumbers.join(
                                                                            ", "
                                                                          )
                                                                        : unit.batchNumbers}
                                                                    </div>
                                                                  </div>
                                                                )
                                                              )}
                                                            </Accordion.Body>
                                                          </Accordion.Item>
                                                        </Accordion>
                                                      )}
                                                    <div className="d-flex mt-2 gap-2">
                                                      <div>
                                                        <input
                                                          style={{
                                                            width: "100px",
                                                          }}
                                                          type="number"
                                                          step="any"
                                                          className={`form-control ${
                                                            fieldErrors[
                                                              `${product.id}-${dto.id}`
                                                            ]?.quantity
                                                              ? "is-invalid"
                                                              : ""
                                                          }`}
                                                          placeholder="Qty"
                                                          id={`input-${dto.id}`}
                                                          disabled={!isChecked}
                                                          defaultValue={
                                                            defaultQuantity ||
                                                            ""
                                                          }
                                                          onWheel={(e) =>
                                                            e.target.blur()
                                                          }
                                                          onChange={(e) => {
                                                            const inputValue =
                                                              e.target.value;
                                                            const newQuantity =
                                                              parseFloat(
                                                                inputValue
                                                              );

                                                            if (
                                                              inputValue ===
                                                                "" ||
                                                              isNaN(
                                                                newQuantity
                                                              ) ||
                                                              newQuantity <= 0
                                                            ) {
                                                              setFieldErrors(
                                                                (prev) => ({
                                                                  ...prev,
                                                                  [`${product.id}-${dto.id}`]:
                                                                    {
                                                                      ...(prev[
                                                                        `${product.id}-${dto.id}`
                                                                      ] || {}),
                                                                      quantity:
                                                                        "Enter qty",
                                                                    },
                                                                })
                                                              );
                                                            } else {
                                                              setFieldErrors(
                                                                (prev) => ({
                                                                  ...prev,
                                                                  [`${product.id}-${dto.id}`]:
                                                                    {
                                                                      ...(prev[
                                                                        `${product.id}-${dto.id}`
                                                                      ] || {}),
                                                                      quantity:
                                                                        null,
                                                                    },
                                                                })
                                                              );
                                                              handleUpdateQuantity(
                                                                dto,
                                                                newQuantity,
                                                                index
                                                              );
                                                            }
                                                          }}
                                                        />
                                                        {fieldErrors[
                                                          `${product.id}-${dto.id}`
                                                        ]?.quantity && (
                                                          <div
                                                            className="text-danger"
                                                            style={{
                                                              fontSize:
                                                                "0.85em",
                                                            }}
                                                          >
                                                            {
                                                              fieldErrors[
                                                                `${product.id}-${dto.id}`
                                                              ].quantity
                                                            }
                                                          </div>
                                                        )}
                                                      </div>

                                                      <div>
                                                        <select
                                                          className={`form-select ${
                                                            fieldErrors[
                                                              `${product.id}-${dto.id}`
                                                            ]?.unit
                                                              ? "is-invalid"
                                                              : ""
                                                          }`}
                                                          defaultValue={
                                                            defaultUnitId
                                                          }
                                                          onChange={(e) => {
                                                            const selectedUnitId =
                                                              e.target.value;
                                                            const unitId =
                                                              selectedUnitId ===
                                                              ""
                                                                ? null
                                                                : selectedUnitId;

                                                            if (!unitId) {
                                                              setFieldErrors(
                                                                (prev) => ({
                                                                  ...prev,
                                                                  [`${product.id}-${dto.id}`]:
                                                                    {
                                                                      ...(prev[
                                                                        `${product.id}-${dto.id}`
                                                                      ] || {}),
                                                                      unit: "Select unit",
                                                                    },
                                                                })
                                                              );
                                                            } else {
                                                              setFieldErrors(
                                                                (prev) => ({
                                                                  ...prev,
                                                                  [`${product.id}-${dto.id}`]:
                                                                    {
                                                                      ...(prev[
                                                                        `${product.id}-${dto.id}`
                                                                      ] || {}),
                                                                      unit: null,
                                                                    },
                                                                })
                                                              );
                                                            }

                                                            handleUpdateUnit(
                                                              dto,
                                                              unitId,
                                                              index
                                                            );
                                                          }}
                                                        >
                                                          <option value="">
                                                            Select Unit
                                                          </option>
                                                          {dto.allDispensingUnits?.map(
                                                            (unit) => (
                                                              <option
                                                                key={unit.id}
                                                                value={unit.id}
                                                              >
                                                                {unit.name}
                                                              </option>
                                                            )
                                                          )}
                                                        </select>
                                                        {fieldErrors[
                                                          `${product.id}-${dto.id}`
                                                        ]?.unit && (
                                                          <div
                                                            className="text-danger"
                                                            style={{
                                                              fontSize:
                                                                "0.85em",
                                                            }}
                                                          >
                                                            {
                                                              fieldErrors[
                                                                `${product.id}-${dto.id}`
                                                              ].unit
                                                            }
                                                          </div>
                                                        )}
                                                      </div>

                                                      {!dto.allDispensingUnits?.some(
                                                        (unit) =>
                                                          unit.id ===
                                                          Number(
                                                            product.dosageQntyUnitId
                                                          )
                                                      ) && (
                                                        <div
                                                          className="text-warning mt-2"
                                                          style={{
                                                            fontSize: "0.9em",
                                                          }}
                                                        >
                                                          <strong>
                                                            Dosage unit not
                                                            available.
                                                          </strong>
                                                        </div>
                                                      )}
                                                    </div>
                                                    <Accordion
                                                      style={{
                                                        padding: 0,
                                                        marginTop: "1em",
                                                      }}
                                                    >
                                                      <Accordion.Item eventKey="0">
                                                        <Accordion.Header
                                                          style={{
                                                            padding: 0,
                                                            margin: 0,
                                                            "--bs-accordion-btn-padding-x":
                                                              "0.5rem",
                                                            "--bs-accordion-btn-padding-y":
                                                              "0.5rem",
                                                          }}
                                                        >
                                                          Select Batches
                                                        </Accordion.Header>
                                                        <Accordion.Body
                                                          style={{
                                                            padding: "10px",
                                                            marginTop: "10px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            className="form-control mb-2"
                                                            placeholder="Search batch"
                                                            onChange={async (
                                                              e
                                                            ) => {
                                                              const searchText =
                                                                e.target.value;
                                                              const response =
                                                                await getSuggestedMedicalProductBatches(
                                                                  dto.id,
                                                                  product.numberOfDays,
                                                                  searchText
                                                                );
                                                              if (
                                                                response &&
                                                                response.data
                                                              ) {
                                                                setSuggestedMedicalProductBatchList(
                                                                  (prev) => ({
                                                                    ...prev,
                                                                    [batchKey]:
                                                                      response
                                                                        .data
                                                                        .data,
                                                                  })
                                                                );
                                                              } else {
                                                                setSuggestedMedicalProductBatchList(
                                                                  (prev) => ({
                                                                    ...prev,
                                                                    [batchKey]:
                                                                      [],
                                                                  })
                                                                );
                                                              }
                                                            }}
                                                          />
                                                          {suggestedBatches?.length >
                                                          0 ? (
                                                            <>
                                                              {suggestedBatches.map(
                                                                (batch) => (
                                                                  <div
                                                                    key={
                                                                      batch.id
                                                                    }
                                                                    className="form-check mb-1"
                                                                  >
                                                                    <input
                                                                      className="form-check-input"
                                                                      type="checkbox"
                                                                      id={`batch-${batch.id}-${batchKey}`}
                                                                      checked={selectedBatchIds?.includes(
                                                                        batch.id
                                                                      )}
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        handleBatchCheckboxChange(
                                                                          batchKey,
                                                                          batch.id,
                                                                          e
                                                                            .target
                                                                            .checked
                                                                        );
                                                                        setSelectedMedicalProductList(
                                                                          (
                                                                            prevSelected
                                                                          ) => {
                                                                            const match =
                                                                              (
                                                                                item
                                                                              ) =>
                                                                                item.medicineId ===
                                                                                  product.id &&
                                                                                item.medicalProductId ===
                                                                                  dto.id;
                                                                            return prevSelected.map(
                                                                              (
                                                                                item
                                                                              ) => {
                                                                                if (
                                                                                  match(
                                                                                    item
                                                                                  )
                                                                                ) {
                                                                                  let batches =
                                                                                    Array.isArray(
                                                                                      item.medicalProductBatches
                                                                                    )
                                                                                      ? [
                                                                                          ...item.medicalProductBatches,
                                                                                        ]
                                                                                      : [];
                                                                                  if (
                                                                                    e
                                                                                      .target
                                                                                      .checked
                                                                                  ) {
                                                                                    if (
                                                                                      !batches.includes(
                                                                                        batch.id
                                                                                      )
                                                                                    ) {
                                                                                      batches.push(
                                                                                        batch.id
                                                                                      );
                                                                                    }
                                                                                  } else {
                                                                                    batches =
                                                                                      batches.filter(
                                                                                        (
                                                                                          id
                                                                                        ) =>
                                                                                          id !==
                                                                                          batch.id
                                                                                      );
                                                                                  }
                                                                                  return {
                                                                                    ...item,
                                                                                    medicalProductBatches:
                                                                                      batches,
                                                                                  };
                                                                                }
                                                                                return item;
                                                                              }
                                                                            );
                                                                          }
                                                                        );
                                                                      }}
                                                                    />
                                                                    <label
                                                                      className="form-check-label ms-2"
                                                                      htmlFor={`batch-${batch.id}-${batchKey}`}
                                                                    >
                                                                      {
                                                                        batch.batchNumber
                                                                      }{" "}
                                                                      -{" "}
                                                                      <span>
                                                                        Available
                                                                        Qty:{" "}
                                                                        {"  "}{" "}
                                                                      </span>
                                                                      {
                                                                        batch.currentQuantityValue
                                                                      }{" "}
                                                                      <span className="ms-1 txt-warning">
                                                                        (
                                                                        {
                                                                          batch.expiryMessage
                                                                        }
                                                                        )
                                                                      </span>
                                                                    </label>
                                                                  </div>
                                                                )
                                                              )}
                                                            </>
                                                          ) : (
                                                            <div className="text-muted">
                                                              No batches found.
                                                            </div>
                                                          )}
                                                        </Accordion.Body>
                                                      </Accordion.Item>
                                                    </Accordion>
                                                  </>
                                                )}
                                              </span>
                                            </div>
                                          </Fragment>
                                        );
                                      }
                                    )}
                                  </div>
                                ) : (
                                  <span className="ms-2">(Not available)</span>
                                )}
                              </div>
                            </Fragment>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </>
              )}

              {showMedicalBillCodes && (
                <>
                  <div className="d-flex justify-content-between flex-wrap mb-3">
                    <p className="txt-warning">
                      {medicalProductBillCodeList?.message}
                    </p>
                    <Button
                      className="primary "
                      onClick={handleBackToSelectMedicalProduct}
                      buttonTitle={"Back"}
                    />
                  </div>
                  {medicalProductBillCodeList?.availableBillCodes?.length >
                    0 && (
                    <div
                      className="checklist p-2"
                      style={{
                        minHeight: "200px",
                        maxHeight: "400px",
                        height: "auto",
                        overflowY: "auto",
                      }}
                    >
                      <div className="list">
                        <h5>Selected available products:</h5>

                        {medicalProductBillCodeList?.availableBillCodes
                          ?.length > 0 ? (
                          medicalProductBillCodeList.availableBillCodes.map(
                            (bill, index) => (
                              <div
                                key={`bill-${bill.medicineId}-${index}`}
                                className={`mb-2 product-div `}
                              >
                                <p>
                                  <span className="fw-bold">{bill.name}</span> (
                                  {bill.description})
                                  <p>
                                    <span className="txt-warning">
                                      {bill.warningMessage}
                                    </span>
                                  </p>
                                </p>

                                <div className="d-flex flex-wrap justify-content-between gap-3">
                                  <p>
                                    <span className="fw-bold">Qty:</span>{" "}
                                    {bill.quantityWithUnit}
                                  </p>
                                  <p>
                                    <span className="fw-bold">Rate: </span>{" "}
                                    {bill.rate}{" "}
                                    {isBillWithGst && (
                                      <>
                                        {bill.cgst
                                          ? `| CGST: ${bill.cgst}%`
                                          : ""}{" "}
                                        {bill.sgst
                                          ? `| SGST: ${bill.sgst}%`
                                          : ""}{" "}
                                      </>
                                    )}
                                  </p>
                                  <p>
                                    <span className="fw-bold">Amount: </span>{" "}
                                    {bill.amount}
                                  </p>
                                </div>
                              </div>
                            )
                          )
                        ) : (
                          <p>No available products.</p>
                        )}
                      </div>
                    </div>
                  )}

                  {medicalProductBillCodeList?.unavailableBillCodes?.length >
                    0 && (
                    <div
                      className="checklist p-2"
                      style={{
                        minHeight: "200px",
                        maxHeight: "400px",
                        height: "auto",
                        overflowY: "auto",
                      }}
                    >
                      <div className="list">
                        <h5>Selected unavailable products:</h5>
                        {medicalProductBillCodeList.unavailableBillCodes.map(
                          (bill, index) => (
                            <div
                              key={`unavailable-bill-${bill.medicineId}-${index}`}
                              className={`mb-2 product-div `}
                            >
                              <p>
                                <span className="fw-bold">{bill.name}</span> (
                                {bill.description})
                              </p>
                              <div className="d-flex flex-wrap justify-content-between gap-3">
                                <p>
                                  <span className="fw-bold">Qty:</span>{" "}
                                  {bill.quantityWithUnit}
                                </p>
                                <p>
                                  <span className="fw-bold">Rate: </span>{" "}
                                  {bill.rate ? bill.rate : DATA_NOT_AVAILABLE}
                                </p>
                                <p>
                                  <span className="fw-bold">Amount: </span>{" "}
                                  {bill.amount
                                    ? bill.amount
                                    : DATA_NOT_AVAILABLE}
                                </p>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <h4 className="mt-2 text-center">Invoice</h4>

              {!(
                (props?.appointmentId !== null && props?.appointmentId) ||
                props.appointmentInfo !== undefined
              ) &&
                props?.isGenerateInvoiceWithoutAppointmentModal && (
                  <div>
                    <h5 className="mt-2 pt-2 titleColor">
                      Select Invoice Generation Option
                    </h5>
                    <div className="d-flex flex-row mt-3">
                      <div className="mr-4 form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="withAppointment"
                          name="withAppointment"
                          value="true"
                          checked={withAppointment}
                          onChange={(e) => handleChangeInvoiceGeneration(e)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="withAppointment"
                        >
                          With Appointment
                        </label>
                      </div>
                      <div className="mx-4 form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="isOtherTreatmentPlan"
                          name="withAppointment"
                          value="false"
                          checked={!withAppointment}
                          onChange={(e) => handleChangeInvoiceGeneration(e)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="isOtherTreatmentPlan"
                        >
                          Without Appointment
                        </label>
                      </div>
                    </div>
                  </div>
                )}

              <div>
                <div className="d-flex justify-content-between flex-wrap">
                  {!(
                    (props?.appointmentId !== null && props?.appointmentId) ||
                    props.appointmentInfo !== undefined
                  ) && props?.isGenerateInvoiceWithoutAppointmentModal ? (
                    <>
                      {withAppointment ? (
                        <button
                          className="txt-primary bg-transparent border-0 mt-4  mb-2"
                          type="button"
                          onClick={() => {
                            toggleSelectAppointmentModal();
                          }}
                        >
                          <h5>
                            {`${
                              selectedItems.length === 0
                                ? "Select Appointment"
                                : `Selected Appointment(${selectedItems.length})`
                            }`}
                          </h5>
                        </button>
                      ) : (
                        <>
                          <div className="d-flex flex-column col-md-4 mt-3">
                            <div className="form-floating">
                              <CreatableSelect
                                id="type"
                                name="type"
                                options={clientList}
                                onChange={(selectedOption) => {
                                  if (selectedOption) {
                                    setSelectedClient(selectedOption.id);
                                  } else {
                                    setSelectedClient("");
                                  }
                                }}
                                placeholder="Select client"
                                onInputChange={handleInputChange}
                                isMulti={false}
                                required
                                isClearable
                                isValidNewOption={() => false}
                                styles={{
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            </div>
                            <div className="form-floating mb-2 mt-2 col-md-12">
                              <CreatableSelect
                                id="address"
                                name="address"
                                options={orgAddressList}
                                onChange={(selectedOption) => {
                                  if (selectedOption) {
                                    setAddressId(selectedOption?.id);
                                  } else {
                                    setAddressId("");
                                  }
                                }}
                                placeholder="Select Address"
                                isMulti={false}
                                required
                                isClearable
                                isValidNewOption={() => false}
                                styles={{
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <label className="invoiceLabel">
                        {props.hospitalizationId
                          ? "Hospitalization Id: "
                          : "Appointment Id: "}{" "}
                        {props?.isEditInvoiceModal
                          ? props?.appointmentId == null
                            ? props?.hospitalizationId
                              ? props?.hospitalizationId
                              : "Not Available"
                            : props?.appointmentId
                          : props?.appointmentInfo?.id
                          ? props?.appointmentInfo?.id
                          : props.hospitalizationId}
                      </label>
                    </>
                  )}

                  <div className="d-flex justify-content-between date mt-3">
                    <div className="full-width">
                      <label className="dateLabel mb-2">Invoice Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="invoiceDate"
                        min={
                          props?.appointmentDetails?.visitDate
                            ? moment(props.appointmentDetails.visitDate).format(
                                "YYYY-MM-DD"
                              )
                            : undefined
                        }
                        // max={new Date().toJSON().split("T")[0]}
                        defaultValue={
                          props.isEditInvoiceModal &&
                          props?.Invoice?.createDate !== 0
                            ? moment(props?.Invoice?.createDate).format(
                                "YYYY-MM-DD"
                              )
                            : moment(todaysDate).format("YYYY-MM-DD")
                        }
                        onChange={(e) => {
                          let invoiceCreateDate = new Date(
                            e.target.value
                          ).getTime();

                          const date = moment(
                            props?.Invoice?.createDate
                          ).format("YYYY-MM-DD");

                          if (
                            date === e.target.value &&
                            props.isEditInvoiceModal
                          ) {
                            setInvoiceCreateDate(props?.Invoice?.createDate);
                          } else {
                            setInvoiceCreateDate(
                              isNaN(invoiceCreateDate)
                                ? undefined
                                : invoiceCreateDate
                            );
                          }
                        }}
                        // disabled //made this disabled as create date should not be user input(system time)
                      />
                    </div>
                    <div className="full-width">
                      <label className="dateLabel mb-2">Invoice Due Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="dueDate"
                        min={new Date().toJSON().split("T")[0]}
                        defaultValue={
                          props.isEditInvoiceModal &&
                          props?.Invoice?.dueDate !== 0
                            ? moment(props?.Invoice?.dueDate).format(
                                "YYYY-MM-DD"
                              )
                            : moment(todaysDate).format("YYYY-MM-DD")
                        }
                        onChange={(e) => {
                          let invoiceDueDate = new Date(
                            e.target.value
                          ).getTime();
                          setInvoiceDueDate(
                            isNaN(invoiceDueDate) ? undefined : invoiceDueDate
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>

                {!(
                  (props?.appointmentId !== null && props?.appointmentId) ||
                  props.appointmentInfo !== undefined ||
                  props?.hospitalizationId
                ) &&
                  !withAppointment && (
                    <div className=" txt-warning text-center mt-2">
                      Invoice without associated appointment.
                    </div>
                  )}

                {organizationDto?.isMedicalInventory  && !props?.hospitalizationId&& (
                  <>
                    {!(
                      (props?.appointmentId !== null && props?.appointmentId) ||
                      props.appointmentInfo !== undefined 
                    ) &&
                      withAppointment && (
                        <div>
                          <button
                            className="txt-primary bg-transparent border-0 addRow"
                            type="button"
                            onClick={handleShowSelectMedicalProduct}
                            disabled={
                              selectedItems.length === 0 ||
                              isPrescriptionLoading ||
                              isMedicalProductListLoading
                            }
                          >
                            <i className="bi bi-plus-circle me-2" />
                            Select Medical Product
                          </button>
                        </div>
                      )}

                    {props.isEditInvoiceModal ||
                    !props?.generateInvoiceWithoutAppointment ||
                    (props.isEditInvoiceModal === false &&
                      !props?.generateInvoiceWithoutAppointment) ? (
                      <div>
                        <button
                          className="txt-primary bg-transparent border-0 addRow"
                          type="button"
                          onClick={handleShowSelectMedicalProduct}
                          disabled={
                            isPrescriptionLoading || isMedicalProductListLoading
                          }
                        >
                          <i className="bi bi-plus-circle me-2" />
                          Select Medical Product
                        </button>
                      </div>
                    ) : null}
                  </>
                )}

                <label className="invoiceLabel mt-2">
                  Enter invoice information
                </label>

                {isShowBillArray ? (
                  <>
                    <SectionLoader />
                  </>
                ) : (
                  <>
                    <TableContainer id="tableDiv">
                      <Table className="tableInvoice">
                        <EnhancedTableHead
                          order={"asc"}
                          orderBy={""}
                          onRequestSort={() => ""}
                          rowCount={billArray.length}
                          headCells={headCells}
                        />

                        <TableBody className="table">
                          {(
                            billArray &&
                            (packageList.length > 0
                              ? [...billArray, ...packageList]
                              : billArray)
                          ).map((item, i) => (
                            <TableRow key={"Invoice-" + i}>
                              <TableCell
                                data-cell={
                                  headCells[getColumnIndexByLabel("No")].label
                                }
                              >
                                {i + 1}
                              </TableCell>

                              <TableCell
                                className="widthInput1"
                                data-cell={
                                  headCells[getColumnIndexByLabel("Name")].label
                                }
                              >
                                <input
                                  className="form-control"
                                  type="text"
                                  name="name"
                                  value={item.name}
                                  disabled={
                                    (item.newPackage !== undefined &&
                                      item.newPackage) ||
                                    item.isMedicine ||
                                    item.isVaccine ||
                                    item.medicalProductBatchId ||
                                    item.hospitalizationId ||
                                    item?.hospitalizationRoomId ||
                                    item?.checkUpIds
                                  }
                                  onChange={(e) => {
                                    setIsSelectBillCode(true);
                                    debouncedFunction(e);
                                    handleChange(e, i);
                                    setErrorMessage((prev) => ({ [i]: null }));
                                  }}
                                  onKeyDown={(e) =>
                                    e.key === "Backspace"
                                      ? null
                                      : e.key === "Enter"
                                      ? setIsSelectBillCode(false)
                                      : null
                                  }
                                  autoComplete="off"
                                />
                                {billCodeList.length !== 0 &&
                                  rowNoToGenerateDropdown === i &&
                                  isSelectedBillCode && (
                                    <div className="billCodeResult">
                                      {billCodeList
                                        .slice(0, 10)
                                        .map((value, key) => (
                                          <span key={value.id + key}>
                                            <label
                                              className="billRow"
                                              name="name"
                                              onClick={(e) => {
                                                handleChange(e, i, value);
                                                setIsSelectBillCode(false);
                                                setErrorMessage((prev) => ({
                                                  ...prev,
                                                  [i]: null,
                                                }));
                                              }}
                                            >
                                              {value.name}
                                            </label>
                                            <br />
                                          </span>
                                        ))}
                                    </div>
                                  )}
                              </TableCell>

                              {isBillWithGst && (
                                <TableCell
                                  className="widthInput2"
                                  onClick={() => setIsSelectBillCode(false)}
                                  data-cell={
                                    headCells[
                                      getColumnIndexByLabel("HSN/SAC Code")
                                    ].label
                                  }
                                >
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="hsn_sac_code"
                                    autoComplete="off"
                                    value={item.hsn_sac_code}
                                    disabled={
                                      item.newPackage !== undefined &&
                                      item.newPackage
                                    }
                                    onChange={(e) => {
                                      handleChange(e, i);
                                      setErrorMessage((prev) => ({
                                        ...prev,
                                        [i]: null,
                                      }));
                                    }}
                                  />
                                </TableCell>
                              )}

                              <TableCell
                                className="widthInput2"
                                onClick={() => setIsSelectBillCode(false)}
                                data-cell={
                                  headCells[
                                    getColumnIndexByLabel("Description")
                                  ].label
                                }
                              >
                                <input
                                  className="form-control"
                                  type="text"
                                  name="descr"
                                  autoComplete="off"
                                  value={item.descr}
                                  disabled={
                                    item.newPackage !== undefined &&
                                    item.newPackage
                                  }
                                  onChange={(e) => {
                                    handleChange(e, i);
                                    setErrorMessage((prev) => ({
                                      ...prev,
                                      [i]: null,
                                    }));
                                  }}
                                />
                              </TableCell>

                              <TableCell
                                data-cell={
                                  headCells[getColumnIndexByLabel("Qty")].label
                                }
                                className="widthInput3"
                              >
                                <input
                                  className="form-control"
                                  name="qnty"
                                  autoComplete="off"
                                  value={
                                    item.qnty || item.qnty === 0
                                      ? item.qnty
                                      : ""
                                  }
                                  disabled={
                                    item.newPackage !== undefined &&
                                    item.newPackage
                                  }
                                  onChange={(e) => {
                                    handleChange(e, i);
                                    setErrorMessage((prev) => ({
                                      ...prev,
                                      [i]: null,
                                    }));
                                  }}
                                />
                              </TableCell>

                              <TableCell
                                data-cell={
                                  headCells[getColumnIndexByLabel("Disc")].label
                                }
                                className="tax-discount"
                              >
                                <div className="percent-wrap p-0">
                                  <input
                                    className="form-control text-percent"
                                    name="discount"
                                    autoComplete="off"
                                    style={{ padding: "4px" }}
                                    value={
                                      item.discount || item.discount === 0
                                        ? item.discount
                                        : ""
                                    }
                                    onChange={(e) => {
                                      if (e.target.value <= 100) {
                                        if (
                                          item.newPackage !== undefined &&
                                          item.newPackage
                                        ) {
                                          handleChangeServicePack(
                                            e,
                                            item,
                                            i - billArray.length
                                          );
                                        } else {
                                          handleChange(e, i);
                                        }
                                      }
                                      setErrorMessage((prev) => ({
                                        ...prev,
                                        [i]: null,
                                      }));
                                    }}
                                  />
                                  <span className="percent-code">%</span>
                                </div>
                              </TableCell>

                              {isBillWithGst && (
                                <>
                                  <TableCell
                                    data-cell={
                                      headCells[getColumnIndexByLabel("CGST")]
                                        .label
                                    }
                                    className="tax-discount"
                                  >
                                    <div className="percent-wrap p-0">
                                      <input
                                        className="form-control text-percent"
                                        name="cgst"
                                        autoComplete="off"
                                        style={{ padding: "4px" }}
                                        value={
                                          item.cgst || item.cgst === 0
                                            ? item.cgst
                                            : ""
                                        }
                                        disabled={
                                          item.newPackage !== undefined &&
                                          item.newPackage
                                        }
                                        onChange={(e) => {
                                          handleChange(e, i);
                                          setErrorMessage((prev) => ({
                                            ...prev,
                                            [i]: null,
                                          }));
                                        }}
                                      />
                                      <span className="percent-code">%</span>
                                    </div>
                                  </TableCell>
                                  <TableCell
                                    data-cell={
                                      headCells[getColumnIndexByLabel("SGST")]
                                        .label
                                    }
                                    className="tax-discount"
                                  >
                                    <div className="percent-wrap p-0">
                                      <input
                                        className="form-control text-percent"
                                        name="sgst"
                                        autoComplete="off"
                                        style={{ padding: "4px" }}
                                        value={
                                          item.sgst || item.sgst === 0
                                            ? item.sgst
                                            : ""
                                        }
                                        disabled={
                                          item.newPackage !== undefined &&
                                          item.newPackage
                                        }
                                        onChange={(e) => {
                                          handleChange(e, i);
                                          setErrorMessage((prev) => ({
                                            ...prev,
                                            [i]: null,
                                          }));
                                        }}
                                      />
                                      <span className="percent-code">%</span>
                                    </div>
                                  </TableCell>
                                </>
                              )}

                              <TableCell
                                data-cell={
                                  headCells[getColumnIndexByLabel("Rate")].label
                                }
                                className="widthInput4"
                              >
                                <input
                                  className="form-control numeric"
                                  name="rate"
                                  autoComplete="off"
                                  value={
                                    item.rate || item.rate === 0
                                      ? item.rate
                                      : ""
                                  }
                                  disabled={
                                    item.newPackage !== undefined &&
                                    item.newPackage
                                  }
                                  onChange={(e) => {
                                    handleChange(e, i);
                                    setErrorMessage((prev) => ({
                                      ...prev,
                                      [i]: null,
                                    }));
                                  }}
                                />
                              </TableCell>

                              <TableCell
                                data-cell={
                                  headCells[getColumnIndexByLabel("Amount")]
                                    .label
                                }
                                className="widthInput5"
                              >
                                <input
                                  className="form-control numeric"
                                  type="number"
                                  name="amount"
                                  disabled={
                                    item.newPackage !== undefined &&
                                    item.newPackage
                                  }
                                  value={
                                    item?.amount || item?.amount === 0
                                      ? item.amount
                                      : ""
                                  }
                                  onChange={(e) => {
                                    const maxAllowedValue =
                                      +item.rate * +item.qnty;
                                    if (e.target.value <= maxAllowedValue) {
                                      handleChange(e, i);
                                      setErrorMessage((prev) => ({
                                        ...prev,
                                        [i]: null,
                                      }));
                                    } else {
                                      setErrorMessage((prev) => ({
                                        ...prev,
                                        [i]: `Amount cannot exceed ${maxAllowedValue}`,
                                      }));
                                    }
                                  }}
                                />
                                {errorMessage[i] && (
                                  <span className="error-message">
                                    {errorMessage[i]}
                                  </span>
                                )}
                              </TableCell>

                              <TableCell data-cell={"Action"}>
                                <div className="d-flex gap-1 p-0">
                                  <IconButton
                                    className="error small px-1"
                                    style={{ height: "max-content" }}
                                    type="button"
                                    onClick={() => {
                                      if (
                                        item.newPackage !== undefined &&
                                        item.newPackage
                                      ) {
                                        handleDeletePackageRow(
                                          i - billArray.length,
                                          item
                                        );
                                      } else {
                                        if (
                                          item.isMedicalProcedure &&
                                          item?.medicalProcedureName
                                        ) {
                                          handleDeleteRow(
                                            i,
                                            item?.medicalProcedureName
                                          );
                                        } else if (
                                          item?.hsrCode &&
                                          props?.isEditInvoiceModal
                                        ) {
                                          handleDeleteRow(i, item?.hsrCode);
                                        } else {
                                          handleDeleteRow(i, item.name);
                                        }
                                      }
                                    }}
                                  >
                                    <i className="bi bi-x-circle" />
                                  </IconButton>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>

                      <button
                        className="txt-primary bg-transparent border-0 addRow"
                        type="button"
                        onClick={handleAddRow}
                      >
                        <i className="bi bi-plus-circle me-2" />
                        Add a line Item
                      </button>
                    </TableContainer>
                  </>
                )}

                {preDefinedPackageList &&
                  preDefinedPackageList.length !== 0 && (
                    <button
                      className="txt-primary bg-transparent border-0"
                      type="button"
                      onClick={toggleBuyPackageModal}
                    >
                      <i className="bi bi-arrow-up-circle me-2" />
                      Buy Package
                    </button>
                  )}

                <div
                  className={
                    (props?.appointmentId !== null ||
                      props.appointmentInfo !== undefined) &&
                    !props?.isGenerateInvoiceWithoutAppointmentModal
                      ? "d-flex flex-wrap justify-content-between"
                      : "d-flex flex-wrap justify-content-end"
                  }
                >
                  {(props?.appointmentId !== null || props.appointmentInfo) &&
                    !props?.isGenerateInvoiceWithoutAppointmentModal && (
                      <>
                        <div className="m-2 d-flex flex-wrap packageTable">
                          {validPackageList &&
                            validPackageList.length !== 0 &&
                            isShowPackages && (
                              <div>
                                <div className="d-flex gap-1 my-1">
                                  <input
                                    className="form-check-input"
                                    name="consumePackage"
                                    type="checkbox"
                                    checked={isConsumePackage}
                                    disabled={
                                      validPackageList &&
                                      !validPackageList.length
                                    }
                                    onChange={(e) => {
                                      setIsConsumePackage(e.target.checked);
                                      if (!e.target.checked) {
                                        setServicePackageId("");
                                      }
                                    }}
                                  />
                                  <p className="m-0">
                                    Use a session from package
                                  </p>
                                </div>
                                <div className="form-floating">
                                  <select
                                    className={`form-select`}
                                    id="servicePackage"
                                    aria-label="servicePackage"
                                    as="select"
                                    name="servicePackage"
                                    value={servicePackageId}
                                    onChange={(e) => {
                                      setServicePackageId(
                                        !+e.target.value ? "" : +e.target.value
                                      );
                                      setNoOfSessionsConsumed(1);
                                    }}
                                    disabled={!isConsumePackage}
                                  >
                                    <option value="">Use Package</option>
                                    {validPackageList &&
                                      validPackageList
                                        .sort((a, b) =>
                                          a.name.localeCompare(b.name)
                                        )
                                        .map((item) => (
                                          <option key={item.id} value={item.id}>
                                            {item.name}
                                          </option>
                                        ))}
                                  </select>
                                  <label htmlFor="servicePackage">
                                    <span>Use Package</span>
                                  </label>
                                </div>
                              </div>
                            )}

                          {isConsumePackage &&
                            servicePackageId &&
                            isShowPackages &&
                            validPackageList.length !== 0 && (
                             <div class="row">
                                <div className="ms-2 col-12 txt-warning mt-3">
                                  {validPackageList.find(
                                    (item) => item.id === servicePackageId
                                  )
                                    ? `Service Pack is valid from  ${convertDateToString(
                                        validPackageList.find(
                                          (item) => item.id === servicePackageId
                                        ).purchaseDate
                                      )} 
                        
                           ${
                             validPackageList.find(
                               (item) => item.id === servicePackageId
                             ).validityDate
                               ? " to " +
                                 convertDateToString(
                                   validPackageList.find(
                                     (item) => item.id === servicePackageId
                                   ).validityDate
                                 )
                               : ""
                           }`
                                    : ""}
                                </div>
                                <div className="col-12 mt-2">
                                  {validPackageList.find(
                                    (item) => item.id === servicePackageId
                                  ) ? (
                                    <div className="col-md-12 mt-2 ">
                                      <label htmlFor="noOfSessionConsumed">
                                        <span>Sessions consumed </span>
                                      </label>
                                      <input
                                        style={{
                                          width: "150px",
                                          textAlign: "right",
                                        }}
                                        className="form-control values mt-1"
                                        name="noOfSessionConsumed"
                                        autoComplete="off"
                                        type="number"
                                        value={noOfSessionConsumed}
                                        disabled={
                                          props?.isEditTreatmentModal &&
                                          props?.treatmentPlanDetails
                                            ?.organizationId === null
                                            ? true
                                            : false
                                        }
                                        onChange={handleConsumeCount}
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            )}

                          {isConsumePackage &&
                            servicePackageId &&
                            isShowPackages &&
                            validPackageList.length !== 0 && (
                              <div className="m-1 d-flex align-items-center remainingSession ms-2">
                                {`Remaining session: ${
                                  validPackageList &&
                                  !packageObj &&
                                  isShowPackages &&
                                  findPackageById(
                                    validPackageList,
                                    servicePackageId
                                  )
                                    ? !findPackageById(
                                        validPackageList,
                                        servicePackageId
                                      ).remainingSessions &&
                                      findPackageById(
                                        validPackageList,
                                        servicePackageId
                                      ).remainingSessions !== 0
                                      ? findPackageById(
                                          validPackageList,
                                          servicePackageId
                                        ).numSessions
                                      : findPackageById(
                                          validPackageList,
                                          servicePackageId
                                        ).remainingSessions
                                    : validPackageList &&
                                      packageObj &&
                                      isShowPackages &&
                                      servicePackageId &&
                                      !findPackageById(
                                        validPackageList,
                                        servicePackageId
                                      ).remainingSessions &&
                                      findPackageById(
                                        validPackageList,
                                        servicePackageId
                                      ).remainingSessions !== 0
                                    ? findPackageById(
                                        validPackageList,
                                        servicePackageId
                                      ).numSessions
                                    : findPackageById(
                                        validPackageList,
                                        servicePackageId
                                      ).remainingSessions
                                }
        `}
                              </div>
                            )}
                        </div>
                      </>
                    )}

                  <div className="d-flex  justify-content-end totalSubtotalDiv">
                    <div className="d-flex flex-column tableBottom">
                      <label className="text-center">Total</label>
                      <label className="pt-2 txt-primary text-center totalLabel">
                        {formatTotal(+total)}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter className="">
          {hideSelectMedicalProduct ? (
            <>
              {showMedicalBillCodes === false && (
                <Button
                  className="primary"
                  isLoading={isMedicalProductListLoading}
                  disabled={
                    isMedicalProductListLoading ||
                    medicalProductList?.length === 0 ||
                    (selectedMedicalProductList.length === 0 &&
                      !props.isEditInvoiceModal) ||
                    hasFieldErrors()
                  }
                  onClick={handleCallMedicalProductBillCodes}
                  buttonTitle={"Check Availability"}
                />
              )}

              {showMedicalBillCodes && (
                <Button
                  className="primary"
                  onClick={handleHideSelectMedicalProduct}
                  disabled={
                    medicalProductBillCodeList?.availableBillCodes?.length ===
                      0 ||
                    medicalProductBillCodeList?.availableBillCodes ===
                      undefined ||
                    isMedicalProductBillCodeListLoading ||
                    (selectedMedicalProductList.length === 0 &&
                      !props.isEditInvoiceModal)
                  }
                  buttonTitle={
                    props?.isEditInvoiceModal
                      ? "Update Invoice"
                      : "Add to Invoice"
                  }
                />
              )}

              <Button
                className="secondary outline"
                type="button"
                onClick={handleCancelSelectMedicalProduct}
              >
                Cancel
              </Button>
            </>
          ) : (
            <>
              <Button
                className="primary"
                onClick={handleAddInvoice}
                isLoading={isAddInvoiceLoading}
                disabled={isAddInvoiceLoading}
                buttonTitle={
                  props?.isEditInvoiceModal ? "Update  Invoice" : "Generate"
                }
              />
              <Button
                className="secondary outline"
                type="button"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </>
          )}
        </ModalFooter>
      </Modal>
      <AddBillCodeForGenerateInvoice
        show={startAddBillCodeModal && !isConsultantUser}
        onHide={toggleAddBillCodeModal}
        billItem={billItemToSave}
        getUpdatedList={getUpdatedList}
        indexOfNewBillItem={indexOfNewBillItem}
        handleModalClose={handleModalClose}
      />
      <BuyPackageModal
        show={isBuyPackageModal}
        validPackageList={validPackageList}
        predefinedPackagesList={
          props?.Invoice?.predefinedPackagesList?.length > 0
            ? props?.Invoice?.predefinedPackagesList
            : []
        }
        onHide={toggleBuyPackageModal}
        updateSubtotalTotalForPackage={updateSubtotalTotalForPackage}
        preDefinedPackageList={preDefinedPackageList}
        setNewPackList={setNewPackList}
        newPackList={newPackList}
        purchaseDate={
          props.appointmentInfo
            ? props.appointmentInfo?.visitDate
            : props.appointmentDetails?.visitDate
        }
        appointmentId={props?.appointmentId}
      />
      <SelectAppointmentModal
        show={isSelectAppointmentModal}
        onHide={toggleSelectAppointmentModal}
        isConsultantUser={isConsultantUser}
        setSelectedItems={(app) => setSelectedItems(app)}
        preSelectedFilterItems={selectedItems}
        setSelectedAppointment={(appointment) =>
          setSelectedAppointment(appointment)
        }
        selectedAppointment={selectedAppointment}
        setIsAppointmentSelected={setIsAppointmentSelected}
      />
    </div>
  );
}
